import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Modal from 'react-bootstrap/Modal';
import { SlButton, SlDrawer } from '@shoelace-style/shoelace/dist/react';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import Button from 'react-bootstrap/Button';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import { useDispatch, useSelector } from 'react-redux';
import api from "../../services/api"
import { Toast } from '../../shared/Toast'
import { formatDate, formatDateWithTime, ISODateString, NEWISODateString } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { classifiedCreatives, copyText, dfpBackfillAdTypes, magazineCreatives, paymentNames, recadCreatives, removeCommonLocation, roles, updateBlockerFlag, widgetCreatives } from "../../utils/constants";
import { SetComponentId } from '../../redux/counterSlice'
import LineItemMcModal from "./LineItemMcModal";
import PreviewFrameEdit from "../PreviewFrameEdit";

import createdSVG from "../../../src/assets/images/created.svg"
import runningSVG from "../../../src/assets/images/running.svg"
import pausedSVG from "../../../src/assets/images/paused.svg"
import completedSVG from "../../../src/assets/images/completed.svg"
import scheduledSVG from "../../../src/assets/images/scheduled.svg"
import copySvg from "../../../src/assets/images/copy.svg";
import approved from "../../../src/assets/images/request.svg"
import { SetlineItemsFlag } from "../../redux/counterSlice";
import LineitemReports from "../lineitemReport/LineitemReports";
import LineitemPreview from "../campaign/LineitemPreview";
import PendingRequestModal from "../MakerChecker/components/PendingRequestModal";

// const mc_role = localStorage.getItem('mc_role');

function LineItemsTableView(props) {
    let data = props.data
    let loader = props.loader
    let dateFilter = props.dateFilter
    const dispatch = useDispatch()
    dispatch(SetComponentId(3))
    const [editDaily_cap, seteditDaily_cap] = useState(0)
    const [editDaily_cap_ind, seteditDaily_cap_ind] = useState(-1)
    const [editTotal_cap_ind, seteditTotal_cap_ind] = useState(-1)
    const [editTotal_cap, seteditTotal_cap] = useState(0)
    const [editTotalBudget_ind, seteditTotalBudget_ind] = useState(-1);
    const [editPosition_ind, seteditPosition_ind] = useState(-2)
    const [editPriority_ind, seteditPriority_ind] = useState(-1)
    const [editPriority, seteditPriority] = useState(-2)
    const [editTotalBudget, seteditTotalBudget] = useState(-1);
    const [editPosition, seteditPosition] = useState(-2)
    const [editTotalDaily_ind, seteditDailyBudget_ind] = useState(-1);
    const [editDailyBudget, seteditDailyBudget] = useState(-1);
    const [editstart_date_ind, seteditStart_date_ind] = useState(-1);
    const [editstart_date, seteditStart_date] = useState(0)
    const [editend_date_ind, seteditEnd_date_ind] = useState(-1);
    const [currentDate, setCurrentDate] = useState("")
    const [editend_date, seteditEnd_date] = useState(0);
    const [editCampName, setEditCampName] = useState("")
    const [editCampNameInd, setEditCampNameInd] = useState("")
    const [actual_target, setactual_target] = useState({})
    const [actual_hidden_target, setactual_hidden_target] = useState({})
    const [hidden_target_preview, setHidden_target_preview] = useState({})
    const [deldetails, setdeldetails] = useState({})
    const [xshow, setxshow] = useState({})
    const [xvalue, setxvalue] = useState('')
    const [logshow, setlogshow] = useState({})
    const [logdata, setLogdata] = useState([])
    const [delshow, setdelshow] = useState(false)
    const [deptlist, setDepartment] = useState([])
    const [previewdata, setPreview] = useState({});
    const [campCategory, setCampCategory] = useState([])
    const [brandsList, setBrandsList] = useState([])
    const [localHeadsList, setLocalHeadsList] = useState([])
    const [creative_Names, setCreative_Names] = useState([])
    const [orderBudget, setOrderBudget] = useState({})
    const [showMessForm, setShowMessForm] = useState({})
    const [discMess, setDiscMess] = useState("")
    const [stopMessObj, setStopMessObj] = useState({})
    const [positionWise, setPositionWise] = useState([])
    const [ipBasedStats, setIPBasedStats] = useState(false)
    const [dfpEncLI, setDfpEncLI] = useState({})
    const [lIReportDetails, setLIReportDetails] = useState(null)
    const [shareLink, setShareLink] = useState(null)
    const [dfpCloneMultipleData, setDfpCloneMultipleData] = useState({})
    const [dfpAdCodesData, setDfpAdCodesData] = useState({})
    const lineItemsFlag = useSelector(state => state.Head.lineItemsFlag)

    const [isDisabled, setisDisabled] = useState(null)
    const [showActionsMenu, setShowActionsMenu] = useState(-1)
    const [expandedLi, setExpandedLi] = useState(-1)
    const [tarshow, setTarshow] = useState(false)
    const [openMcModal, setOpenMcModal] = useState(false)

    const [lineitemPrev, setLineitemPrev] = useState(null)

    const navigate = useNavigate()
    const [targetdetails, setTargetdetails] = useState({
        age: { min: '', max: '' }
    })
    useEffect(() => {
        const role = localStorage.getItem("role");
        if (role !== roles.ops && role !== roles.financer)
            navigate("/home/order");
    }, []);
    var timeslots = [{ sdate: '', edate: '' }]
    useEffect(() => {
        setCurrentDate(NEWISODateString())
    }, [])
    useEffect(() => {
        seteditDaily_cap(0)
        seteditDaily_cap_ind(-1)
        seteditTotal_cap_ind(-1)
        seteditTotal_cap(0)
        seteditTotalBudget_ind(-1)
        seteditTotalBudget(0)
        seteditDailyBudget_ind(-1)
        seteditDailyBudget(0)
        seteditStart_date_ind(-1)
        seteditStart_date(0)
        seteditEnd_date_ind(-1)
        seteditEnd_date(0)
        seteditPosition(-2)
        seteditPosition_ind(-2)
        seteditPriority(-1)
        seteditPriority_ind(-1)
        setEditCampName("")
        setEditCampNameInd(-1)
        setShowActionsMenu(-1)
    }, [data])

    const tableEdit = async (datatype, data, campaign_id, campaign_type, old_data, campaign_name, camp) => {
        if (old_data === data)
            return
        if (datatype === "position" && (parseInt(data) <= 0)) {
            Toast("error", "Position must be greater than 0")
            return
        }
        if (datatype === "total_budget" && +data > +old_data) {
            // RO balance is validated only when increasing; reducing the budget is always allowed
            try {
                let ro_details_result = await api({
                    url: "/order/getOrdervalue",
                    method: "POST",
                    responseType: "json",
                    data: { campaign_id, order_id: camp.order_id }
                })
                let ro_details = ro_details_result?.data
                if (ro_details.total < +data + +ro_details.spent) {
                    Toast("error", `RO balance is ${ro_details.total - ro_details.spent}`)
                    return
                }

            } catch (error) {
                console.log("Error @ TOTAL BUDGET edit RO calculation", error)
                Toast("error", "Some thing went wrong")
                return
            }
        }
        if (datatype === "start_date" || datatype === "end_date" || datatype === "position") {
            const start_date = datatype === "start_date" ? campaign_type === "CPD" ? ISODateString(data) : ISODateString(data) : campaign_type === "CPD" ? ISODateString(camp.start_date) : ISODateString(camp.start_date)
            const end_date = datatype === "end_date" ? campaign_type === "CPD" ? ISODateString(data) : ISODateString(data) : campaign_type === "CPD" ? "" : ISODateString(camp.end_date)
            let target = await api({
                url: '/user/target/getTarget',
                method: 'POST',
                responseType: 'json',
                data: { campaign_id: campaign_id }
            })
            if (datatype === "position" && campaign_type === "CPD") {

                const actual_target = await removeCommonLocation(target.data.lang_ids, target.data.state_ids, target.data.district_ids, target.data.mandal_ids, target.data.village_ids, target.data.exclude)
                if (actual_target.lang_ids.length || actual_target.state_ids.length || actual_target.district_ids.length) {
                    const old_slot = getpos(parseInt(old_data))
                    const new_slot = getpos(parseInt(data))
                    if (old_slot !== new_slot) {
                        Toast("error", `Position must be in range ${old_slot}`)
                        return
                    }
                }
                else {
                    let old_mandal_slot = getmandal_pos(parseInt(old_data))
                    let new_mandal_slot = getmandal_pos(parseInt(data))
                    if (old_mandal_slot !== new_mandal_slot) {
                        Toast("error", `Position must be in range ${old_mandal_slot}`)
                        return
                    }

                }
            }
            try {
                let res = await api({
                    url: '/lineitems/tableEdit',
                    method: 'POST',
                    responseType: 'json',
                    data: {
                        campaign_id,
                        data, datatype,
                        campaign_type,
                        old_data,
                        campaign_name,
                        post_ids: camp.post_ids || [],
                        type: camp.type,
                        status: camp.status,
                        creative_type: camp.creative_type,
                        creative_ids: camp.creative_ids
                    }
                })
                if (res.code === 200) {
                    // getData(search, currentPage, status, dateFilter, campaignType, departmentHandle, filter_sales_ops, x_filter, payment_status_filter, target_filter)
                    dispatch(SetlineItemsFlag(!lineItemsFlag))
                }
            } catch (error) {
                console.error(error)
            }
        }
        else {
            try {
                let reqObject = {
                    campaign_id,
                    data, datatype,
                    campaign_type,
                    old_data,
                    campaign_name,
                    type: camp.type
                }
                if (datatype === "priority") {
                    reqObject.post_ids = camp.post_ids
                    reqObject.creative_ids = camp.creative_ids
                    reqObject.creative_type = camp.creative_type
                }
                let res = await api({
                    url: '/lineitems/tableEdit',
                    method: 'POST',
                    responseType: 'json',
                    data: reqObject
                })
                if (res.code === 200) {
                    // getData(search, currentPage, status, dateFilter, campaignType, departmentHandle, filter_sales_ops, x_filter, payment_status_filter, target_filter)
                    dispatch(SetlineItemsFlag(!lineItemsFlag))
                }
                else {
                    Toast("error", res?.data?.message || "Something went wrong refresh the page")
                }
            } catch (error) {
                console.error(error)
            }
        }


    }
    const result1 = {
        datavariable: [],
        type: "",
        action: "",
        id: "",
        start: {
            "campaign_name": "",
            "type": "",
            "campaign_type": "",
        },
        budget: {
            "total_budget": 0,
            "daily_budget": 0,
            "cpm": 0,
            "tot_imp_cap": 0,
            "tot_click_cap": 0,
            "daily_imp_cap": 0,
            "cpd": 0,
            "daily_click_cap": 0,
            "cpc_price": 0
        },
        creatselect: {
            "creative_ids": [],
            "position": 0,
            "positiontype": "",
            "frequency_cap": 0,
            "ad_code": "",
            "line_item_code": "",
            "creative_type": "",
            "webview_creative_type": "",
            "frequency_cap_type": "",
            "post_type": "",
            "news_type": "",
            "fileUrl":"",
            "description":""

        },
        date: {
            start_date: "",
            end_date: "",
            datelist: [{ sdate: "", edate: "" }]
        },
        target: {
            "target_id": 0,
            "locations": [],
            "lang_ids": [],
            "os": "",
            "app": [],
            "minspend": []
        },
        order_id: ""
    }

    // const updateDiscount = async (index, id, act, discMess)=>{
    //     const result = await api({
    //         url: '/lineitems/updateDiscountMess',
    //             method: 'POST',
    //             responseType: 'json',
    //             data: {
    //                 id,
    //                 discMess
    //             }
    //     })
    //     if(result?.code ===200){
    //         console.log(result)
    //         editAction(index, id, act)
    //     }
    // }
    const getRejectedReason = async(campaign_id)=>{
        console.log(campaign_id);
        try {
            let res = await api({
                url: '/lineitems/getlineitempackage',
                method: 'POST',
                responseType: 'json',
                data: { campaign_id}
            })
            if(res.code == 200)
            {  
               result1.creatselect.fileUrl = res.data?.desc_url;
               result1.creatselect.description = res.data?.desc_reason
            }
        }
        catch(err)
        {
            console.log(err);
        }
    }
    const editAction = (index, id, act) => {
        if (data[index].order_status !== 1 && (act === "approve" || act === "resume") && data[index].ispackage) {
            Toast("error", `Order is ${data[index].order_status === 2 ? 'Paused' : 'Completed'}`)
            setisDisabled(null)
            return
        }
        result1.status = data[index].status
        result1.action = act
        result1.id = id
        result1.type = data[index].type;
        result1.start.campaign_name = data[index].campaign_name
        result1.start.type = data[index].type
        result1.start.brand_id = +data[index].brand_id
        result1.start.campaign_type = data[index].campaign_type
        // result1.start.brand_type = data[index].brand_type
        result1.budget.total_budget = data[index].total_budget
        result1.budget.daily_budget = data[index].daily_budget
        result1.budget.cpm = data[index].cpm
        result1.budget.tot_imp_cap = data[index].tot_imp_cap
        result1.budget.tot_click_cap = data[index].tot_click_cap
        result1.budget.daily_imp_cap = data[index].daily_imp_cap
        result1.budget.daily_click_cap = data[index].daily_click_cap
        result1.creatselect.cpd = data[index].cpd
        result1.budget.cpc_price = data[index].cpc_price;
        result1.creatselect.position = data[index].position
        result1.creatselect.creative_type = data[index].creative_type
        result1.creatselect.webview_creative_type = data[index].webview_creative_type
        result1.creatselect.positiontype = data[index].position_type
        result1.creatselect.frequency_cap_type = data[index].frequency_cap_type
        result1.creatselect.frequency_cap = data[index].frequency_cap
        result1.creatselect.ad_code = data[index].ad_code
        result1.creatselect.line_item_code = data[index].line_item_code
        result1.creatselect.dfp_creative_ids = data[index].dfp_creative_ids ? data[index].dfp_creative_ids.join(',') : data[index].dfp_creative_ids
        result1.creatselect.post_type = data[index].post_type
        result1.creatselect.news_type = data[index].news_type
        result1.creatselect.dfp_backfill_ad_type = data[index].dfp_backfill_ad_type || ''
        result1.creatselect.design_type = data[index].design_type || 0
        result1.creatselect.full_scr_type = data[index].full_scr_type || 0
        result1.creatselect.slotuuid = data[index].slotuuid || ''
        result1.creatselect.banner_size = data[index].banner_size ? data[index].banner_size.split(',') : []
        result1.creatselect.creative_ids = data[index].creative_ids
        result1.creatselect.action_type = data[index].action_type
        result1.creatselect.encryption = data[index].encryption
        result1.creatselect.dfp_hidden = data[index].dfp_hidden
        result1.creatselect.dfp_ima = data[index].dfp_ima || false
        result1.creatselect.dfp_ima_obs = data[index].dfp_ima_obs || false
        result1.creatselect.dfp_pgdeal = data[index].dfp_pgdeal || false
        result1.date.ser_24_hrs = data[index].ser_24_hrs || false
        result1.creatselect.actual_running_cpd = data[index].cpd || 0
        result1.creatselect.actual_running_creative_type = data[index].creative_type || ''
        result1.creatselect.ad_reach = data[index].ad_reach
        result1.creatselect.dir_serve = data[index].dir_serve
        result1.creatselect.dir_prmry_serv = data[index].dir_prmry_serv ? true : false
        result1.creatselect.share_ad = data[index].share_ad
        result1.creatselect.priority = data[index].priority ? data[index].priority : 1
        result1.creatselect.sov = data[index].sov === 1 ? true : false
        result1.order_id = data[index].order_id
        result1.creatselect.is_backfill = data[index].is_backfill
        result1.start.category_id = data[index].category_id
        result1.start.sub_category_id = data[index].sub_category_id
        if(data[index].creative_type === "brandAd" || magazineCreatives.includes(data[index].creative_type)){
            result1.isBrandAd = true
            result1.creatselect.brand_post_ids = data[index].post_ids?.length ? data[index].post_ids.join(',') : ''
        }
        if(data[index].creative_type === 'commentad'){
            result1.creatselect.brand_post_ids = data[index].post_ids?.length ? data[index].post_ids.join(',') : ''
        }
        if(classifiedCreatives.includes(data[index].creative_type)){
            result1.isClassified = true
        }
        if(magazineCreatives.includes(data[index].creative_type) && !data[index].position){
            data[index].position = null
        }
        if (act === "preview") {
            result1.discount_obj = data[index].discount_obj
            result1.brand_name = data[index].brand_name
        }
        if (act === "edit") {
            if (data[index].campaign_type !== 'CPD' || data[index].creative_type === "brandAd" || magazineCreatives.includes(data[index].creative_type)) {
                result1.date.end_date = ISODateString(data[index].end_date)
                result1.date.start_date = ISODateString(data[index].start_date)
            } else {
                result1.date.start = ISODateString(data[index].start_date)
            }
            let dtime = data[index].day_time_slots
            for (let i = 0; i < dtime.length; i++) {
                dtime[i]['sdate'] = ISODateString(dtime[i]['sdate'])
                dtime[i]['edate'] = ISODateString(dtime[i]['edate'])
            }
            result1.date.datelist = dtime
            result1.plusdisable = true
            result1.sameday = false
        }
        else {
            result1.date.end_date = data[index].end_date
            result1.date.start_date = data[index].start_date

            let dtime = data[index].day_time_slots
            result1.date.datelist = dtime
        }
        if (act === "preview") {
            result1.grouped = data[index].grouped
            result1.creatselect.discApp = data[index].discount_obj?.discApp
        }
        getTarget(id, act, index)
    }
    const getTarget = async (campaign_id, action, index) => {
        try {
            let res = await api({
                url: '/user/target/getTarget',
                method: 'POST',
                responseType: 'json',
                data: { campaign_id: campaign_id }
            })

            if (Object.keys(res.data).length) {
                setactual_target(await removeCommonLocation(res.data.lang_ids, res.data.state_ids, res.data.district_ids, res.data.mandal_ids, res.data.village_ids, res.data.exclude))
                setTargetdetails(res.data)
            }
            if (action === "edit") {
                const orderDetailsResult = await api({
                    url: "lineitems/getOrderDetails",
                    responseType: "json",
                    data: { order_id: data[index].order_id },
                    method: "POST"
                })
                result1.order = orderDetailsResult.data
                if (data[index].status === 5 || data[index].status === 2)
                    await updateBlockerFlag(campaign_id, true)
                if (JSON.stringify(res.data) !== '{}') {
                    if(res.data.zone_ids?.length){
                        result1.target.zone_ids = res.data.zone_ids
                        result1.target.state_ids = []
                        result1.target.district_ids = []
                        result1.target.mandal_ids = []
                        result1.target.village_ids = []
                    }else{
                        result1.target.state_ids = res.data.state_ids
                        result1.target.zone_ids = []
                        result1.target.district_ids = res.data.district_ids
                        result1.target.mandal_ids = res.data.mandal_ids
                        result1.target.village_ids = res.data.village_ids
                    }
                    result1.target.lang_ids = res.data.lang_ids
                    result1.target.os = res.data.os
                    result1.target.minspend = res.data.minspend
                    result1.target.app = res.data.app_category
                    result1.target.min_age = res.data.age.min === '' ? '' : parseInt(res.data.age.min)
                    result1.target.max_age = res.data.age.max === '' ? '' : parseInt(res.data.age.max)
                    result1.target.android_version = res.data.versions.android_version || ''
                    result1.target.ios_version = res.data.versions.ios_version || ''
                    result1.target.gender = res.data.gender
                    result1.target.target_id = res.data.target_id
                    result1.target.exclude = res.data.exclude
                    result1.target.constituency_ids = res.data.constituency_ids
                }
                await getRejectedReason(campaign_id);
                navigate("/home/campaign/start", { state: result1 })
            }
            else {
                if (JSON.stringify(res.data) !== '{}') {
                    result1.target.zone_ids = res.data.zone_ids
                    result1.target.state_ids = res.data.state_ids
                    result1.target.district_ids = res.data.district_ids
                    result1.target.mandal_ids = res.data.mandal_ids
                    result1.target.village_ids = res.data.village_ids
                    result1.target.lang_ids = res.data.lang_ids
                    result1.target.os = res.data.os
                    result1.target.minspend = res.data.minspend
                    result1.target.app = res.data.app_category
                    result1.target.min_age = res.data.age.min === '' ? '' : parseInt(res.data.age.min)
                    result1.target.max_age = res.data.age.max === '' ? '' : parseInt(res.data.age.max)
                    result1.target.android_version = res.data.versions.android_version || ''
                    result1.target.ios_version = res.data.versions.ios_version || ''
                    result1.target.gender = res.data.gender
                    result1.target.target_id = res.data.target_id
                    result1.target.exclude = res.data.exclude
                    result1.target.constituency_ids = res.data.constituency_ids
                    if (localStorage.getItem('role') === roles.ops) {
                        try {
                            let hidden_target_result = await api({
                                url: '/user/target/getHiddenTarget',
                                method: 'POST',
                                responseType: 'json',
                                data: { campaign_id: campaign_id }
                            })
                            if (Object.keys(hidden_target_result.data).length) {
                                setactual_hidden_target(await removeCommonLocation(hidden_target_result.data.lang_ids, hidden_target_result.data.state_ids, hidden_target_result.data.district_ids, hidden_target_result.data.mandal_ids, hidden_target_result.data.village_ids, 0))
                                setHidden_target_preview(hidden_target_result.data)
                            }
                        } catch (error) {
                            console.error("Error @ hidden_target api in campaigns table")
                        }
                    }

                }
            }
            setPreview(result1)
            if (action === "approve") {
                try {
                    let ro_details_result = await api({
                        url: "/order/getOrdervalue",
                        method: "POST",
                        responseType: "json",
                        data: { campaign_id, order_id: data[index].order_id }
                    })
                    let ro_details = ro_details_result?.data
                    let budget = parseFloat(+data[index].total_budget ? +data[index].total_budget : +data[index].cpd).toFixed(2)
                    if (ro_details.total < +budget + +ro_details.spent) {
                        setOrderBudget({ order_value: ro_details.total, order_spent: ro_details.spent, order_balance: parseFloat(ro_details.total - ro_details.spent).toFixed(2), lineItemBudget: budget, result1 })
                        setisDisabled(null)
                        return
                    }

                } catch (error) {
                    console.log("Error @ Publish RO calculation", error)
                    Toast("error", "Some thing went wrong")
                    return
                }
                insertIntoredis(result1, "approve")
            }
            if (action === "pause") {
                insertIntoredis(result1, "pause")
            }
            if (action === "resume") {
                insertIntoredis(result1, "resume")
            }
            if (action === "completed") {
                insertIntoredis(result1, "completed")
            }

        }
        catch (erre) {
            setisDisabled(null)
            console.error(erre)
        }
    }
    // const removeCommonLocation = (lang_ids, state_ids, district_ids, mandal_ids, village_ids, exclude) => {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             let mandalRes = [], districtRes = [], statesRes = [], villageRes = [], mandaldum = [], districtdum = [], statedum = [], langdum = [];
    //             let ex_villages = [], ex_mandals = [], ex_districts = [], states = [], mandalsinlist = [], districtinlist = [], statesinlist = [], villagesinlist = [];
    //             if (mandal_ids.length) mandalsinlist = mandal_ids.map(j => +j.mandal_id);
    //             if (district_ids.length) districtinlist = district_ids.map(j => +j.dist_id);
    //             if (state_ids.length) statesinlist = state_ids.map(j => +j.state_id);
    //             if (village_ids.length) villagesinlist = village_ids.map(j => +j.village_id)
    //             if (village_ids.length) mandaldum = village_ids.map(j => +j.mandal_id)
    //             if (mandal_ids.length) districtdum = mandal_ids.map(j => +j.dist_id)
    //             if (district_ids) statedum = district_ids.map(j => +j.state_id)
    //             if (state_ids) langdum = state_ids.map(j => +j.lang_id)
    //             if (exclude) {
    //                 if (village_ids.length) {
    //                     ex_villages = villagesinlist
    //                     mandalRes = mandaldum
    //                     villageRes = []
    //                 }
    //                 if (mandal_ids.length) {
    //                     ex_mandals = mandalsinlist.filter(item => !mandaldum.includes(item))
    //                     districtRes = []
    //                     mandal_ids.map((item) => { if (ex_mandals.includes(item.mandal_id)) districtRes.push(+item.dist_id) })
    //                 }
    //                 if (district_ids.length) {
    //                     ex_districts = districtinlist.filter(item => !districtdum.includes(+item))
    //                 }
    //                 statesRes = statesinlist
    //             }
    //             else {
    //                 villageRes = villagesinlist
    //                 statesRes = statesinlist.filter(item => !statedum.includes(item))
    //                 mandalRes = mandalsinlist.filter(item => !mandaldum.includes(item))
    //                 districtRes = districtinlist.filter(item => !districtdum.includes(item))
    //             }
    //             lang_ids = lang_ids.filter(item => !langdum.includes(item))

    //             statesRes = Array.from(new Set(statesRes))
    //             districtRes = Array.from(new Set(districtRes))
    //             mandalRes = Array.from(new Set(mandalRes))
    //             villageRes = Array.from(new Set(villageRes))
    //             ex_districts = Array.from(new Set(ex_districts))
    //             ex_mandals = Array.from(new Set(ex_mandals))
    //             ex_villages = Array.from(new Set(ex_villages))
    //             return resolve({ lang_ids, state_ids: statesRes, district_ids: districtRes, mandal_ids: mandalRes, village_ids: villageRes, ex_villages, ex_mandals, ex_districts })
    //         } catch (error) {
    //             setisDisabled(null)
    //             console.error(error);
    //         }
    //     })
    // }
    function getpos(num) {
        let pos = ""
        if (num === 1) {
            pos = "1";
            return pos
        }
        if (num === 2 || num === 3) {
            pos = "2-3";
            return pos
        }
        if (4 <= num && num <= 5) {
            pos = "4-5";
            return pos
        }
        if (6 <= num && num <= 9) {
            pos = "6-9";
            return pos
        }
        if (11 <= num && num <= 12) {
            pos = "11-12";
            return pos
        }
        if (16 <= num && num <= 19) {
            pos = "16-19";
            return pos
        }
        if (21 <= num && num <= 25) {
            pos = "21-25";
            return pos
        }
        if (26 <= num && num <= 30) {
            pos = "26-30";
            return pos
        }
        if (31 <= num && num <= 40) {
            pos = "31-40";
            return pos
        }
        if (41 <= num && num <= 50) {
            pos = "41-50";
            return pos
        }

        return pos;
    }
    function getmandal_pos(num) {
        let pos = ""
        if (num === 2 || num === 3) {
            pos = "2-3";
            return pos
        }
        if (4 <= num && num <= 5) {
            pos = "4-5";
            return pos
        }
        if (6 <= num && num <= 9) {
            pos = "6-9";
            return pos
        }
        if (11 <= num && num <= 12) {
            pos = "11-12";
            return pos
        }
        if (21 <= num && num <= 35) {
            pos = "21-35";
            return pos
        }
        if (41 <= num && num <= 50) {
            pos = "41-50";
            return pos
        }

        return pos;
    }
    const insertIntoredis = async (result1, action) => {
        try {
            delete result1.start.brand_id
            let requestData = {
                id: result1.id,
                act: action,
                from: true,
                mc_role: localStorage.getItem('mc_role')
            }
            if (action === 'completed')
                requestData.stopMess = stopMessObj.stopMess
            let res = await api({
                url: '/makerchecker/lineitemActionRequest',
                method: 'POST',
                responseType: 'json',
                data: requestData
            });
            setisDisabled(null)
            setStopMessObj({})
            if(res.status==='SUCCESS'){
                if(action === 'approve') Toast('success',`LineItem ${action} Request Sent Successfully`);
                else Toast('success',`LineItem ${action} Successfully`);
            }else{
                Toast('error',res?.data?.message || res?.message || 'Request failed');
            }
            if (res.code === 200) {
                // getData(search, currentPage, status, dateFilter, campaignType, departmentHandle, filter_sales_ops, x_filter, payment_status_filter, target_filter)
                dispatch(SetlineItemsFlag(!lineItemsFlag))
                if (res.data) {
                    Toast("error", res.data)
                }
            }
            if (res.data === "NoSlots") {
                Toast("error", "No slots found")
            }
            if (res.data === 'Invalid action please refresh page') {
                Toast("error", "Invalid action please refresh page")
            }
            if(res.status===403){
                 Toast('error',"You Cannot Perform This Option")
            }
        } catch (error) {
            console.error(error);
            setisDisabled(null)
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const CloneFun = async (index, id, action) => {
        try {
            let res = await api({
                url: '/lineitems/clone',
                method: 'POST',
                responseType: 'json',
                data: { campaign_id: id }
            })
            if (res.status !== 'SUCCESS') {
                Toast("error", res.data.message)
                return
            }
            try {
                let res1 = await api({
                    url: '/user/target/cloneTarget',
                    method: 'POST',
                    responseType: 'json',
                    data: {
                        campid: id,
                        newid: res.data.rows[0].campaign_id
                    }
                })
                if (res1?.code === 200 && res?.code === 200) {
                    Toast('success', 'Inserted Successfully')
                    dispatch(SetlineItemsFlag(!lineItemsFlag))
                } else {
                    if (res1.code !== 200) {
                        let er = res1?.message || "Targets insert failed"
                        Toast("error", er)
                    }
                    else {
                        let er = res?.message || "Something went wrong1"
                        Toast("error", er)
                    }
                }
            } catch (error) {
                let er = error?.response?.message || "Something went wrong2"
                Toast("error", er)
                // if (error?.response?.status === 401)
                // navigate("/")
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong3"
            Toast("error", er)
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const getCategory = async () => {
        try {
            let res = await api({
                url: '/user/campaign/name',
                method: 'GET',
                responseType: 'json'
            })
            setCampCategory(res.data);
        } catch (error) {
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const getDept = async () => {
        try {
            let res = await api({
                url: '/user/sales_persons/department',
                method: 'POST',
                responseType: 'json',
                data: {}
            })
            setDepartment(res.data)
        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const getBrands = async () => {
        try {
            const brandsResult = await api({
                url: 'user/sales_persons/getBrands',
                method: "POST",
                responseType: "json"
            })
            if (brandsResult?.code === 200) {
                setBrandsList(brandsResult.data)
            }
        } catch (error) {
            console.error("Error @ getBrands Campaigns Table", error)
        }
    }
    const getLocalheads = async () => {
        try {
            let res = await api({
                url: "/user/sales_persons/getLocalHeads",
                method: "GET",
                responseType: "json"
            })
            setLocalHeadsList([{ label: "None", value: 0 }, ...res.data])
        } catch (error) {
            console.error("Error @ getLocalheads \n", error)
        }
    }
    const getCreativeNames = async (ids, campaign_id, type) => {
        try {
            let res = await api({
                url: "/lineitems/creative_Names",
                method: "POST",
                responseType: 'json',
                data: { ids, campaign_id, type }
            })
            setCreative_Names(res.data)

        } catch (error) {
            console.error(error)
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const brandAdsPreview = async (post_ids, creative_ids) => {
        try {
            const res = await api({
                url: "lineitems/post_idsPreview",
                method: "POST",
                responseType: 'json',
                data: { post_ids, creative_ids }
            })
            setCreative_Names(res.data)
        } catch (error) {
            console.error('Error @ brandAdsPreview', error)
        }
    }
    const getlogs = async (campaign_id) => {
        try {
            let res = await api({
                url: '/lineitems/getlogs',
                method: 'POST',
                responseType: 'json',
                data: {
                    campaign_id,
                }
            })
            setLogdata(res.data)
        } catch (error) {

        }
    }

    const getPositionWiseStats = async (campaign_id,status) => {
        try {
            let stats = await api({
                url: '/lineitems/positionWiseStats',
                method: 'POST',
                responseType: "json",
                data: { campaign_id,status}
            })
            if (stats.code === 200)
                setPositionWise(stats.data)
        } catch (error) {
            console.error("Error @ getPositionWiseStats", error)
        }
    }

    const getIPBasedStats = async (campaign_id) => {
        try {
            let stats = await api({
                url: '/lineitems/ipBasedStats',
                method: 'POST',
                responseType: "json",
                data: { campaign_id}
            })
            if (stats.code === 200)
                setIPBasedStats(stats.data)
            else
                setIPBasedStats(null)
        }
        catch (error) {
            console.error("Error @ getIPBasedStats", error)
        }
    }

    async function moveToHiddenTarget(item) {
        try {
            let target = await api({
                url: '/user/target/getTarget',
                method: 'POST',
                responseType: 'json',
                data: { campaign_id: item.campaign_id }
            })
            let hiddenTarget = await api({
                url: '/user/target/getHiddenTarget',
                method: 'POST',
                responseType: 'json',
                data: { campaign_id: item.campaign_id }
            })
            navigate("/home/campaign/hiddentarget", { state: { campaign_details: item, campaign_type: item.campaign_type, actual_target: target.data, target: Object.keys(hiddenTarget.data).length ? hiddenTarget.data : null, action: Object.keys(hiddenTarget.data).length ? "Edit" : "Add" } })
        } catch (error) {
            console.error(error)
        }
    }
    function capitalizeFirstLetter(string) {
        if (!string)
            return ""
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    const addxvalue = async (xshow) => {
        if (xvalue && ((xshow.type != "DFP" && parseFloat(xvalue) >= 1) || (xshow.type === "DFP" && parseFloat(xvalue) >= 1 && parseFloat(xvalue) <= 2))) {
            try {
                let res = await api({
                    url: '/lineitems/x_value',
                    method: 'POST',
                    responseType: 'json',
                    data: {
                        campaign_id: xshow.campaign_id,
                        x_value: parseFloat(xvalue)
                    }
                })
                // getData(search, currentPage, status, dateFilter, campaignType, departmentHandle, filter_sales_ops, x_filter, payment_status_filter, target_filter)
                dispatch(SetlineItemsFlag(!lineItemsFlag))
                setxshow({});
                setxvalue('')
            } catch (error) {
                console.error(error)
            }
        } else {

            if ((xshow.type === "DFP" && xvalue > 2)) {
                Toast("error", "For DFP, X Value must be LessThan 2");
            }
            else
                Toast("error", "X Value must greater then or equals to 1")
        }

    }
    const fun = (id, dept) => {


        if (dept === "category") {
            for (let i = 0; i < campCategory.length; i++) {
                if (campCategory[i].value === id) {
                    return (campCategory[i].label)
                }
            }
            return "NULL"
        }
        if (dept === "depart") {
            for (let i = 0; i < deptlist.length; i++) {
                if (deptlist[i].value === id) {
                    return (deptlist[i].label)
                }
            }
            return "NULL"
        }
        if (dept === "brand") {
            for (let i = 0; i < brandsList.length; i++) {
                if (brandsList[i].value === id) {
                    return (brandsList[i].label)
                }
            }
            return "-"
        }
        if (dept === "localHeads") {
            for (let i = 0; i < localHeadsList.length; i++) {
                if (localHeadsList[i].value === id) {
                    return (localHeadsList[i].label)
                }
            }
            return "-"
        }
    }

    const deleteAction = async (id1) => {
        try {
            let result = await api({
                url: `/lineitems/${id1}`,
                method: "DELETE",
                responseType: "json"
            });
            if (result.code === 200)
                Toast('success', "LineItem Deleted Successfully");
            else
                Toast('error', result.data?.message)
            dispatch(SetlineItemsFlag(!lineItemsFlag))
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const generateEncUrl = async (dfpEncLI) => {
        try {
            setDfpEncLI({ ...dfpEncLI, loader: true, encUrl: "" })
            let apiResp = await api({
                url: "/lineitems/urlEncDFPad",
                method: "POST",
                data: { campaign_id: dfpEncLI.campaign_id, url: dfpEncLI.url, creative_id: dfpEncLI.creative_id },
                responseType: 'json'
            })
            setDfpEncLI({ ...dfpEncLI, loader: false })
            if (apiResp.code === 200) {
                setDfpEncLI({ ...dfpEncLI, encUrl: apiResp.data })
            }
        } catch (error) {
            console.error("Error @ generateEncUrl", error)
        }
    }

    const handleShareLinkAction = async (campaign_id) => {
        try {
            let shareUrlResult = await api({
                url: "/lineitems/getsharelink",
                method: "POST",
                data: { campaign_id },
                responseType: 'json'
            })
            if (shareUrlResult.code == 200) {
                setShareLink(shareUrlResult.data)
            }
        } catch (error) {
            console.error("Error @ handleShareLinkAction", error)
        }
    }

    const closePreview = () => { setTarshow(false); setTargetdetails({}); setactual_target({}); setCreative_Names([]); setPreview({}); setactual_hidden_target({}); setHidden_target_preview({}); setisDisabled(null); setLineitemPrev(null) }

    const updateDfpAdCodes = async (dfpAdCodesData) => {
        const ad_codes = (dfpAdCodesData.ad_codes || "").split(",").map(c => c.trim()).filter(Boolean)
        if (!ad_codes.length) {
            Toast("error", "Enter at least one ad code")
            return
        }
        const duplicates = [...new Set(ad_codes.filter((c, i) => ad_codes.indexOf(c) !== i))]
        if (duplicates.length) {
            Toast("error", `Duplicate ad codes: ${duplicates.join(", ")}`)
            return
        }
        try {
            let result = await api({
                url: "/lineitems/tableEdit",
                method: "POST",
                responseType: 'json',
                data: {
                    campaign_id: dfpAdCodesData.campaign_id,
                    campaign_name: dfpAdCodesData.campaign_name,
                    campaign_type: dfpAdCodesData.campaign_type,
                    type: dfpAdCodesData.type,
                    datatype: "dfp_ad_codes",
                    data: ad_codes,
                    old_data: dfpAdCodesData.old_ad_codes
                }
            })
            if (result.code === 200) {
                Toast('success', "DFP ad codes updated")
                dispatch(SetlineItemsFlag(!lineItemsFlag))
                setDfpAdCodesData({})
            }
            else
                Toast('error', result?.data?.message || "Something went wrong")
        } catch (error) {
            console.error("Error @ updateDfpAdCodes", error)
            Toast("error", "Something went wrong")
        }
    }

    const dfpCloneMultiple = async (dfpCloneMultipleData) => {
        try {
            let copies_details = dfpCloneMultipleData.copies_details.map(c => ({
                campaign_name: c.campaign_name,
                start_date: c.start_date,
                end_date: c.end_date
            }))
            let result = await api({
                url: "/lineitems/dfpCloneMultiple", 
                method: "POST",
                data: { campaign_id: dfpCloneMultipleData.campaign_id, line_item_code: dfpCloneMultipleData.line_item_code, copies_details },
                responseType: 'json'
            })
            if (result.code === 200)
                Toast('success', "Cloning Initiated Please check the lineitem to see progress");
            else
                Toast('error', result.data?.message)
            setDfpCloneMultipleData({})
        } catch (error) {
            console.error("Error @ dfpCloneMultiple", error)
        }
    }

    return (
        <div>
            {/* ---- Mobile-only line items card view (<=767px) ---- */}
            <div className="lineitems-mobile-view">
                {data?.length && !loader ? (
                    data.map((item, index) => {
                        const role = localStorage.getItem("role");
                        const isOps = role === roles.ops;
                        const ic = item.impclicks?.[0] || {};
                        const stMap = { 1: "Created", 2: "Running", 3: "Paused", 4: "Completed", 5: "Scheduled", 6: "Approval" };
                        const stCls = { 1: "pending", 2: "running", 3: "pending", 4: "completed", 5: "running", 6: "pending" };
                        const advClicks = parseInt(ic.adv_total_click > 0 ? ic.adv_total_click : 0);
                        const advImps = parseInt(ic.adv_total_imp > 0 ? ic.adv_total_imp : 0);
                        const actualClicks = parseInt(ic.total_click > 0 ? ic.total_click : 0);
                        const actualImps = parseInt(ic.total_imp > 0 ? ic.total_imp : 0);
                        const advCtr = ic.adv_total_click > 0 && ic.adv_total_imp > 0 ? ((ic.adv_total_click / ic.adv_total_imp) * 100).toFixed(2) : 0;
                        const advEcpm = ic.adv_total_imp > 0 && item.adv_spent > 0 ? ((item.adv_spent / ic.adv_total_imp) * 1000).toFixed(2) : 0;
                        const ctr = ic.total_click > 0 && ic.total_imp > 0 ? ((ic.total_click / ic.total_imp) * 100).toFixed(2) : 0;
                        const ecpm = ic.total_imp > 0 && item.total_spent > 0 ? ((item.total_spent / ic.total_imp) * 1000).toFixed(2) : 0;
                        const dailyBudgetVal = item.campaign_type === "CPD" ? item.cpd : item.daily_budget;
                        const totalBudgetVal = item.campaign_type === "CPD" ? item.cpd : item.total_budget;
                        const dailyCapVal = item.campaign_type === "CPC" ? item.daily_click_cap : item.campaign_type === "CPM" ? item.daily_imp_cap : "-";
                        const totalCapVal = item.campaign_type === "CPC" ? item.tot_click_cap : item.campaign_type === "CPM" ? item.tot_imp_cap : "-";
                        const canEditBudget = item.campaign_type !== "CPD" && item.status !== 1 && item.status !== 6 && isOps;
                        const canEditCap = item.campaign_type !== "CPD" && item.status !== 1 && item.status !== 6 && isOps;
                        const liExpanded = expandedLi === index;
                        const actionsOpen = showActionsMenu === index;
                        return (
                            <div className="om-card li-card" key={item.campaign_id}>
                                <div className="om-card__top">
                                    <div className="om-card__head">
                                        <div className="om-card__oid">
                                            {(role !== roles.advertiser && item.type) ? `${item.type} · ` : ""}{item.campaign_type || "-"}
                                            {item.package_number ? <sl-badge variant="primary">{`${item.package_number} of ${item.package_weeks}`}</sl-badge> : null}
                                        </div>
                                        <div className="om-card__name">
                                            {index === editCampNameInd ? (
                                                <div className="li-edit">
                                                    <input type="text" className="form-control form-control-sm" value={editCampName} onChange={(e) => setEditCampName(e.target.value)} />
                                                    <div className="flex gap-2 mt-1">
                                                        <SlButton size="small" onClick={() => { tableEdit("Campaign Name", editCampName, item.campaign_id, item.campaign_type, item.campaign_name, item.campaign_name, item); setEditCampName(""); setEditCampNameInd(-1) }}>Save</SlButton>
                                                        <SlButton size="small" onClick={() => { setEditCampName(""); setEditCampNameInd(-1) }}>Cancel</SlButton>
                                                    </div>
                                                </div>
                                            ) : (
                                                <span className="flex items-center gap-1">
                                                    <span className="cursor-pointer" onClick={() => { if (item.status !== 1 && item.status !== 5 && item.status !== 6) setLIReportDetails({ campaign_id: item.campaign_id, campaign_name: item.campaign_name, status: item.status, creative_type: item.creative_type }) }}>{item.campaign_name}</span>
                                                    {item.status !== 1 && isOps && (
                                                        <sl-icon-button library="lucide" name="edit" style={{ backgroundColor: "transparent" }} onClick={() => { setEditCampNameInd(index); setEditCampName(item.campaign_name) }}></sl-icon-button>
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                        {item.sales_name && <div className="om-card__company">{item.sales_name}</div>}
                                    </div>
                                    <span className={`om-badge ${stCls[item.status] || "pending"}`}>
                                        <img className="om-badge__icon" src={item.status === 1 ? createdSVG : item.status === 2 ? runningSVG : item.status === 3 ? pausedSVG : item.status === 4 ? completedSVG : item.status === 5 ? scheduledSVG : item.status === 6 ? approved : ""} alt="" />
                                        {stMap[item.status] || "-"}
                                    </span>
                                </div>

                                {(item.discount_obj && !item.discount_obj?.discApp && (isOps || role === roles.salesperson || role === roles.financer)) ? (
                                    <div className="li-discount" title={item.discount_obj?.rejMess || ""}>{item.discount_obj?.rejMess ? "Discount Rejected" : "Discount Pending"}</div>
                                ) : null}

                                <div className="om-card__divider"></div>

                                <div className="om-metrics li-daterow">
                                    <div>
                                        <div className="om-metric__label">Start</div>
                                        {index === editstart_date_ind ? (
                                            <div className="li-edit">
                                                <input type="datetime-local" className="form-control form-control-sm" min={currentDate} value={ISODateString(editstart_date)} onChange={(e) => seteditStart_date(new Date(e.target.value) / 1000)} />
                                                <div className="flex gap-2 mt-1">
                                                    <SlButton size="small" onClick={() => {
                                                        if (editstart_date > item.end_date && item.campaign_type !== "CPD") Toast("error", "Start date must be less than end date")
                                                        else if (editstart_date < ((new Date(currentDate)) / 1000)) Toast("error", "Start date must be greater than current time")
                                                        else if ((ic.total_click && ic.total_click > 0) || (ic.total_imp && ic.total_imp > 0)) Toast("error", "Start date cannot be changed once the campaign is started")
                                                        else { tableEdit("start_date", editstart_date, item.campaign_id, item.campaign_type, item.start_date, item.campaign_name, item); seteditStart_date_ind(-1); seteditStart_date(0) }
                                                    }}>Save</SlButton>
                                                    <SlButton size="small" onClick={() => { seteditStart_date_ind(-1); seteditStart_date(0) }}>Cancel</SlButton>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="li-field__val">
                                                <span className="om-metric__value sm">{formatDateWithTime(item.start_date)}</span>
                                                {(item.status === 5 && isOps && (item.post_ids !== null || (item.creative_type === 'brandAd' || magazineCreatives.includes(item.creative_type) || classifiedCreatives.includes(item.creative_type) || recadCreatives.includes(item.creative_type) || widgetCreatives.includes(item.creative_type)))) ? (
                                                    <sl-icon-button library="lucide" name="edit" style={{ backgroundColor: "transparent" }} onClick={() => { seteditStart_date_ind(index); seteditStart_date(item.start_date) }}></sl-icon-button>
                                                ) : null}
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <div className="om-metric__label">End</div>
                                        {index === editend_date_ind ? (
                                            <div className="li-edit">
                                                <input type="datetime-local" className="form-control form-control-sm" min={currentDate} value={ISODateString(editend_date)} onChange={(e) => seteditEnd_date(new Date(e.target.value) / 1000)} />
                                                <div className="flex gap-2 mt-1">
                                                    <SlButton size="small" onClick={() => {
                                                        if (editend_date < item.start_date) Toast("error", "End date must be greater than Start date")
                                                        else { tableEdit("end_date", editend_date, item.campaign_id, item.campaign_type, item.end_date, item.campaign_name, item); seteditEnd_date_ind(-1); seteditEnd_date(0) }
                                                    }}>Save</SlButton>
                                                    <SlButton size="small" onClick={() => { seteditEnd_date_ind(-1); seteditEnd_date(0) }}>Cancel</SlButton>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="li-field__val">
                                                <span className="om-metric__value sm">{formatDateWithTime(item.end_date)}</span>
                                                {((((item.status === 5 || item.status === 2 || item.status === 3) && (item.campaign_type !== 'CPD' || (item.creative_type === 'brandAd' || magazineCreatives.includes(item.creative_type))) && isOps && item.post_ids !== null)) || (item.campaign_type !== 'CPD' && item.status === 4 && isOps && item.post_ids !== null && (item.campaign_type === "CPM" ? +item.tot_imp_cap > +ic.total_imp : +item.tot_click_cap > +ic.total_click)) && (+item.total_budget > (item.campaign_type === "CPC" ? (parseFloat(item.cpc_price) * parseFloat(ic.total_click ? ic.total_click : 0)).toFixed(2) : ((parseFloat(item.cpm) * parseFloat(ic.total_imp ? ic.total_imp : 0)) / 1000).toFixed(2)))) ? (
                                                    <sl-icon-button library="lucide" name="edit" style={{ backgroundColor: "transparent" }} onClick={() => { seteditEnd_date_ind(index); seteditEnd_date(item.end_date) }}></sl-icon-button>
                                                ) : null}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="om-metrics li-budgetrow">
                                    <div>
                                        <div className="om-metric__label">Daily Budget</div>
                                        {index === editTotalDaily_ind ? (
                                            <div className="li-edit">
                                                <input type="number" className="form-control form-control-sm" value={editDailyBudget} onChange={(e) => seteditDailyBudget(e.target.value)} />
                                                <div className="flex gap-2 mt-1">
                                                    <SlButton size="small" onClick={() => {
                                                        if (parseFloat(editDailyBudget) > parseFloat(item.total_budget)) Toast("error", "Daily budget must be less than Total budget")
                                                        else { tableEdit("daily_budget", editDailyBudget, item.campaign_id, item.campaign_type, item.daily_budget, item.campaign_name, {}); seteditDailyBudget_ind(-1); seteditDailyBudget(0) }
                                                    }}>Save</SlButton>
                                                    <SlButton size="small" onClick={() => { seteditDailyBudget_ind(-1); seteditDailyBudget(0) }}>Cancel</SlButton>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="li-field__val">
                                                <span className="om-metric__value">{dailyBudgetVal}</span>
                                                {canEditBudget && <sl-icon-button library="lucide" name="edit" style={{ backgroundColor: "transparent" }} onClick={() => { seteditDailyBudget_ind(index); seteditDailyBudget(item.daily_budget) }}></sl-icon-button>}
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <div className="om-metric__label">Total Budget</div>
                                        {index === editTotalBudget_ind ? (
                                            <div className="li-edit">
                                                <input type="number" className="form-control form-control-sm" value={editTotalBudget} onChange={(e) => seteditTotalBudget(e.target.value)} />
                                                <div className="flex gap-2 mt-1">
                                                    <SlButton size="small" onClick={() => {
                                                        if (parseFloat(editTotalBudget) < parseFloat(item.daily_budget)) Toast("error", "Total budget must be greater than Daily budget")
                                                        else if ((+editTotalBudget < (item.campaign_type === "CPC" ? (parseFloat(item.cpc_price) * parseFloat(ic.adv_total_click ? ic.adv_total_click : 0)).toFixed(2) : ((parseFloat(item.cpm) * parseFloat(ic.adv_total_imp ? ic.adv_total_imp : 0)) / 1000).toFixed(2)))) Toast("error", "Total budget must be greater than spent")
                                                        else { tableEdit("total_budget", editTotalBudget, item.campaign_id, item.campaign_type, item.total_budget, item.campaign_name, item); seteditTotalBudget_ind(-1); seteditTotalBudget(0) }
                                                    }}>Save</SlButton>
                                                    <SlButton size="small" onClick={() => { seteditTotalBudget_ind(-1); seteditTotalBudget(0) }}>Cancel</SlButton>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="li-field__val">
                                                <span className="om-metric__value">{totalBudgetVal}</span>
                                                {canEditBudget && <sl-icon-button library="lucide" name="edit" style={{ backgroundColor: "transparent" }} onClick={() => { seteditTotalBudget_ind(index); seteditTotalBudget(item.total_budget) }}></sl-icon-button>}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="om-metrics li-caprow">
                                    <div>
                                        <div className="om-metric__label">Daily Cap</div>
                                        {index === editDaily_cap_ind ? (
                                            <div className="li-edit">
                                                <input type="number" className="form-control form-control-sm" value={editDaily_cap} onChange={(e) => seteditDaily_cap(e.target.value)} />
                                                <div className="flex gap-2 mt-1">
                                                    <SlButton size="small" onClick={() => {
                                                        if (parseInt(editDaily_cap) > parseInt(item.campaign_type === "CPM" ? item.tot_imp_cap : item.tot_click_cap)) Toast("error", "Daily cap must be less than Total cap")
                                                        else { tableEdit("daily_cap", editDaily_cap, item.campaign_id, item.campaign_type, item.campaign_type === "CPM" ? item.daily_imp_cap : item.daily_click_cap, item.campaign_name, {}); seteditDaily_cap_ind(-1); seteditDaily_cap(0) }
                                                    }}>Save</SlButton>
                                                    <SlButton size="small" onClick={() => { seteditDaily_cap_ind(-1); seteditDaily_cap(0) }}>Cancel</SlButton>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="li-field__val">
                                                <span className="om-metric__value">{dailyCapVal}</span>
                                                {canEditCap && <sl-icon-button library="lucide" name="edit" style={{ backgroundColor: "transparent" }} onClick={() => { seteditDaily_cap_ind(index); seteditDaily_cap(item.campaign_type === "CPM" ? item.daily_imp_cap : item.daily_click_cap) }}></sl-icon-button>}
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <div className="om-metric__label">Total Cap</div>
                                        {index === editTotal_cap_ind ? (
                                            <div className="li-edit">
                                                <input type="number" className="form-control form-control-sm" value={editTotal_cap} onChange={(e) => seteditTotal_cap(e.target.value)} />
                                                <div className="flex gap-2 mt-1">
                                                    <SlButton size="small" onClick={() => {
                                                        if (parseInt(editTotal_cap) < parseInt(item.campaign_type === "CPM" ? item.daily_imp_cap : item.daily_click_cap)) Toast("error", "Total cap must be greater than Daily cap")
                                                        else { tableEdit("total_cap", editTotal_cap, item.campaign_id, item.campaign_type, item.campaign_type === "CPM" ? item.tot_imp_cap : item.tot_click_cap, item.campaign_name, item); seteditTotal_cap_ind(-1); seteditTotal_cap(0) }
                                                    }}>Save</SlButton>
                                                    <SlButton size="small" onClick={() => { seteditTotal_cap_ind(-1); seteditTotal_cap(0) }}>Cancel</SlButton>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="li-field__val">
                                                <span className="om-metric__value">{totalCapVal}</span>
                                                {canEditCap && <sl-icon-button library="lucide" name="edit" style={{ backgroundColor: "transparent" }} onClick={() => { seteditTotal_cap_ind(index); seteditTotal_cap(item.campaign_type === "CPM" ? item.tot_imp_cap : item.tot_click_cap) }}></sl-icon-button>}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="om-card__divider"></div>

                                <div className="om-metrics">
                                    <div>
                                        <div className="om-metric__label">{isOps ? "Adv Imps" : "Imps"}</div>
                                        <div className="om-metric__value">{advImps}</div>
                                    </div>
                                    <div>
                                        <div className="om-metric__label">{isOps ? "Adv Clicks" : "Clicks"}</div>
                                        <div className="om-metric__value is-link">{advClicks}</div>
                                    </div>
                                    <div>
                                        <div className="om-metric__label">{isOps ? "Adv / Actual Spent" : "Spent"}</div>
                                        <div className="om-metric__value">
                                            {isOps ? (
                                                <span>{item.adv_spent} <span className="li-muted">/ {item.total_spent}</span></span>
                                            ) : item.total_spent}
                                        </div>
                                    </div>
                                </div>

                                {isOps && liExpanded && (
                                    <div className="om-metrics li-extra">
                                        <div>
                                            <div className="om-metric__label">Clicks / Imp</div>
                                            <div className="om-metric__value sm">{actualClicks} / {actualImps}</div>
                                        </div>
                                        <div>
                                            <div className="om-metric__label">Adv CTR/ECPM</div>
                                            <div className="om-metric__value sm">{advCtr}% / {advEcpm}</div>
                                        </div>
                                        <div>
                                            <div className="om-metric__label">CTR/ECPM</div>
                                            <div className="om-metric__value sm">{ctr}% / {ecpm}</div>
                                        </div>
                                        <div>
                                            <div className="om-metric__label">Shares</div>
                                            <div className="om-metric__value sm">{parseInt(ic.shares > 0 ? ic.shares : 0)}</div>
                                        </div>
                                        <div>
                                            <div className="om-metric__label">X Value</div>
                                            <div className="om-metric__value sm">{item.x_value}</div>
                                        </div>
                                    </div>
                                )}

                                <div className="om-card__foot li-foot">
                                    <div className="li-foot__left">
                                        <span className="om-metric__label">POS {item.creative_type !== "brandAd" ? (!magazineCreatives.includes(item.creative_type) ? item.position : (item.position ? item.position : "-")) : "-"}</span>
                                        {isOps && (
                                            <span className="om-txn__more" onClick={() => setExpandedLi(liExpanded ? -1 : index)}>{liExpanded ? "less" : "more stats"}</span>
                                        )}
                                    </div>
                                    <div className="li-actions">
                                        <span style={{ fontSize: "20px" }} className={actionsOpen ? "showMenu" : "hideMenu"}>
                                            {role === roles.ops ? <sl-tooltip content="Clone LineItem" hoist><sl-icon-button library="lucide" name="files" onClick={() => { CloneFun(index, item.campaign_id, 'clone') }}></sl-icon-button></sl-tooltip> : null}
                                            {role === roles.ops ? ((item.status !== 5 && item.status !== 4) ? item.status === 1 ?
                                                (item?.mc_actions || []).length === 0 ? <sl-tooltip content="Request Approve LineItem" hoist>
                                                    <sl-icon-button library="lucide" name="file-check" className="bg-slate-600" onClick={() => {
                                                        if (item.position === -1) { Toast('error', 'Edit and Set Position for this Lineitem to run') }
                                                        else if (item.type !== 'DFP' && item.creative_ids.length === 0) { Toast('error', 'Edit and Set Creatives for this Lineitem to run') }
                                                        else { setisDisabled(false); setLineitemPrev({ index, campaign_id: item.campaign_id, campaign_name: item.campaign_name, act: "approve" }) }
                                                    }} disabled={isDisabled}></sl-icon-button>
                                                </sl-tooltip> : null : (item.status === 2 ?
                                                    <span>
                                                        <sl-tooltip content="Pause LineItem" hoist><sl-icon-button library="lucide" name="pause-circle" label="Pause LineItem" onClick={() => { setisDisabled(false); editAction(index, item.campaign_id, "pause"); }} disabled={isDisabled}></sl-icon-button></sl-tooltip>
                                                        <sl-tooltip content="Stop LineItem" hoist><sl-icon-button library="lucide" name="stop-circle" onClick={() => { setisDisabled(false); setStopMessObj({ stopMess: "", index, campaign_id: item.campaign_id, action: "completed" }) }} disabled={isDisabled}></sl-icon-button></sl-tooltip>
                                                    </span> : item.status === 3 ?
                                                        <span>
                                                            <sl-tooltip content="Resume LineItem" hoist><sl-icon-button library="lucide" name="play-circle" onClick={() => { setisDisabled(false); setLineitemPrev({ index, campaign_id: item.campaign_id, campaign_name: item.campaign_name, act: "resume" }) }} disabled={isDisabled}></sl-icon-button></sl-tooltip>
                                                            <sl-tooltip content="Stop LineItem" hoist><sl-icon-button library="lucide" name="stop-circle" onClick={() => { setisDisabled(false); setStopMessObj({ stopMess: "", index, campaign_id: item.campaign_id, action: "completed" }) }} disabled={isDisabled}></sl-icon-button></sl-tooltip>
                                                        </span> : null) : null) : null}
                                            <sl-tooltip content="View LineItem" hoist><sl-icon-button library="lucide" name="view" onClick={() => { setLineitemPrev({ index, campaign_id: item.campaign_id, campaign_name: item.campaign_name, act: "preview" }); }}></sl-icon-button></sl-tooltip>
                                            {(role === roles.ops && (item.status === 1 || item.status === 2 || (item.status === 5 && Math.floor(new Date().getTime() / 1000) < +item.start_date) || (item.status === 6 && item.admin === "Discount request Pending" && item?.discount_obj?.rejMess))) ? <sl-tooltip content="Edit LineItem" hoist><sl-icon-button library="lucide" name="edit" onClick={() => editAction(index, item.campaign_id, "edit")}></sl-icon-button></sl-tooltip> : null}
                                            {(role === roles.ops && (item.status === 1)) ? <sl-tooltip content="Delete LineItem" hoist><sl-icon-button library="lucide" name="trash-2" onClick={() => { setdelshow(true); setdeldetails({ campaign_id: item.campaign_id, campaign_name: item.campaign_name }) }}></sl-icon-button></sl-tooltip> : null}
                                            {(role === roles.ops) ? <sl-tooltip content="Update logs" hoist><sl-icon-button library="lucide" name="terminal-square" onClick={() => { setlogshow({ campaign_name: item.campaign_name, show: true, campaign_type: item.campaign_type }); getlogs(item.campaign_id) }}></sl-icon-button></sl-tooltip> : null}
                                            {(role === roles.ops) && (item.status === 2 || item.status === 3 || item.status === 5) ? <sl-tooltip content="Assign X Value" hoist><sl-icon-button library="lucide" name="forward" onClick={() => { setxshow({ campaign_id: item.campaign_id, campaign_name: item.campaign_name, show: true, value: null, type: item.type }); setxvalue(item.x_value); }}></sl-icon-button></sl-tooltip> : null}
                                            {(role === roles.ops) && (item.type === "DFP") ? <sl-tooltip content="Clone Multiple" hoist><sl-icon-button library="lucide" name="rotate-ccw" onClick={() => { setDfpCloneMultipleData({ campaign_name: item.campaign_name, campaign_id: item.campaign_id, line_item_code: item.line_item_code, start_date: item.start_date }) }}></sl-icon-button></sl-tooltip> : null}
                                            {(role === roles.ops) && (item.type === "DFP") ? <sl-tooltip content="Edit DFP Ad Codes" hoist><sl-icon-button library="lucide" name="code" onClick={() => { setDfpAdCodesData({ campaign_id: item.campaign_id, campaign_name: item.campaign_name, campaign_type: item.campaign_type, type: item.type, ad_codes: (item.dfp_ad_codes || []).join(", "), old_ad_codes: item.dfp_ad_codes || [] }) }}></sl-icon-button></sl-tooltip> : null}
                                            {((item.status === 2 || item.status === 5) && (item.type !== "DFP" && item.creative_type !== 'commentad') && role === roles.ops) ? <sl-tooltip content="Hidden target" hoist><sl-icon-button library="lucide" name="eye-off" style={{ backgroundColor: "transparent" }} onClick={() => { moveToHiddenTarget(item) }}></sl-icon-button></sl-tooltip> : null}
                                            {((item.status !== 1 && item.status !== 6) && (item.creative_type !== 'commentad') && role === roles.ops) ? <sl-tooltip content="Position Wise Stats" hoist><sl-icon-button library="lucide" name="pie-chart" style={{ backgroundColor: "transparent" }} onClick={() => { getPositionWiseStats(item.campaign_id, item.status) }}></sl-icon-button></sl-tooltip> : null}
                                            {((item.status !== 1 && item.status !== 6) && (item.creative_type !== 'commentad') && role === roles.ops) ? <sl-tooltip content="Actual Stats" hoist><sl-icon-button library="lucide" name="chart-bar" style={{ backgroundColor: "transparent" }} onClick={() => { getIPBasedStats(item.campaign_id) }}></sl-icon-button></sl-tooltip> : null}
                                            {item.type === 'DFP' && (item.status === 2 || item.status === 3 || item.status === 5) ? <sl-tooltip content="Url Encryption" hoist><sl-icon-button library="lucide" name="shield-check" style={{ backgroundColor: "transparent" }} onClick={() => { setDfpEncLI({ campaign_id: item.campaign_id, url: "", encUrl: "", loader: false, creative_id: "" }) }}></sl-icon-button></sl-tooltip> : null}
                                            {(item.status !== 1 && item.status !== 6) && item.type !== 'DFP' && item.creative_type !== 'brandAd' && !magazineCreatives.includes(item.creative_type) && !classifiedCreatives.includes(item.creative_type) && !recadCreatives.includes(item.creative_type) && !widgetCreatives.includes(item.creative_type) ? <sl-tooltip content="Share Link" hoist><sl-icon-button library="lucide" name="share-2" onClick={() => { handleShareLinkAction(item.campaign_id) }}></sl-icon-button></sl-tooltip> : null}
                                        </span>
                                        <sl-tooltip content="Actions" hoist>
                                            <sl-icon-button library="lucide" name={actionsOpen ? "more-horizontal" : "more-vertical"} onClick={() => { setShowActionsMenu(actionsOpen ? -1 : index) }}></sl-icon-button>
                                        </sl-tooltip>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                ) : !data?.length && !loader ? (
                    <div className="text-center py-4 text-gray-500">No line items found</div>
                ) : (
                    <div className="text-center py-4"><TableLoader /></div>
                )}
            </div>
            <div className="mobHide lineitems-desktop-view">
            <ScrollContainer>
                <table className="table table-bordered tableNew">
                    <thead className="sticky top-0">
                        <tr>
                            <th></th>
                            <th>LineItem Name</th>
                            <th>POS</th>
                            {/* {(localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.financer) && <th>PRIO</th>} */}
                            <th className="th-width w100px">Daily/Total Budget</th>
                            <th className="th-width w100px">Daily/Total Cap</th>
                            {(localStorage.getItem("role") === roles.ops) && <th data-toggle="tooltip" data-placement="top" title="Advertiser Imps" className="th-width w100px">Adv Clicks/Imp</th>}
                            {(localStorage.getItem("role") === roles.ops) && <th className="th-width w100px">Adv CTR(%)/ ECPM</th>}
                            <th className="th-width w100px">{localStorage.getItem('role') === roles.advertiser ? "Audience Engaged/Viewed" : localStorage.getItem('role' === roles.salesperson) ? "Clicks/Imp" : "Clicks/Imp"}</th>
                            {(localStorage.getItem("role") === roles.ops) && <th className="th-width w100px">CTR(%)/ ECPM</th>}
                            <th className="th-width w100px">{(localStorage.getItem("role") === roles.ops) ? "Adv/Actual Spent" : "Total Spent"}</th>
                            {(localStorage.getItem("role") === roles.ops) && <th className="th-width w100px">Shares</th>}
                            {(localStorage.getItem("role") === roles.ops) && <th>X Value</th>}
                            {(localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops) && dateFilter ? <th className="th-width w100px">{"Filter (Clicks/Imp)"}</th> : null}
                            {(localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops) && dateFilter ? <th className="th-width w100px">{"Filter Spent"}</th> : null}
                            <th style={{ width: "40px" }}></th>
                        </tr>
                    </thead>
                    {data?.length && !loader ? (
                        <tbody>
                            {data?.map((item, index) => {
                                const showMcDot = item?.mc_actions?.length > 0
                                return (
                                    <tr key={item.campaign_id} className={"group/details hover:bg-slate-100"} >
                                        <td className="posrel pointer">
                                            <div className="flex flex-col gap-2 items-center justify-center">
                                                {showMcDot ? <span className="bg-zinc-700 text-white text-center rounded-full shadow-md px-2 py-1/2" onClick={()=>setOpenMcModal(item?.mc_actions)}>{item?.mc_actions?.length}</span> : null}
                                                {showMcDot && openMcModal === item?.mc_actions ? <LineItemMcModal isOpen={openMcModal?.length > 0} onClose={() => setOpenMcModal([])} data={openMcModal[0]}/>:null}
                                                <img className="svg-icon20" src={item.status === 1 ? createdSVG : item.status === 2 ? runningSVG : item.status === 3 ? pausedSVG : item.status === 4 ? completedSVG : item.status === 5 ? scheduledSVG : item.status === 6 ? approved : ""} />
                                            </div>
                                        </td>
                                        <td className="p-2">
                                            <div class="category">
                                                {localStorage.getItem("role") !== roles.advertiser && <h6 class={item.type === "Editorial" ? "editorial" : item.type === "Local" ? "local" : "dfp"}>{item.type}</h6>}
                                                <h6><sl-badge variant="neutral">{item.campaign_type || "-"}</sl-badge></h6>
                                                {item.package_number ? <h6><sl-badge variant="primary">{`${item.package_number} of ${item.package_weeks}`}</sl-badge></h6> : null}
                                                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.financer)) && item.discount_obj && item.discount_obj?.rejMess && !item.discount_obj?.discApp ? <h6 title={item.discount_obj?.rejMess}>Discount Rejected</h6> : null}
                                                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.financer)) && item.discount_obj && !item.discount_obj?.rejMess && !item.discount_obj?.discApp ? <h6>Discount Pending</h6> : null}
                                            </div>
                                            <h1 class="title success">

                                                {index === editCampNameInd ?
                                                    (<>
                                                        <div className="mb-1">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={editCampName}
                                                                onChange={(e) => {
                                                                    setEditCampName(e.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="flex gap-2">
                                                            <SlButton size="small" onClick={(e) => {
                                                                tableEdit("Campaign Name", editCampName, item.campaign_id, item.campaign_type, item.campaign_name, item.campaign_name, item); setEditCampName(""); setEditCampNameInd(-1)
                                                            }}>Save</SlButton>
                                                            <SlButton size="small" onClick={(e) => { setEditCampName(""); setEditCampNameInd(-1) }}>Cancel</SlButton>
                                                        </div>
                                                    </>) :
                                                    <div className="flex items-center gap-2 group/position">
                                                        {<span className="wgt-600 cursor-pointer" onClick={() => { if (item.status !== 1 && item.status !== 5 && item.status !== 6) setLIReportDetails({ campaign_id: item.campaign_id, campaign_name: item.campaign_name ,status:item.status, creative_type: item.creative_type}) }}>{item.campaign_name}</span>}
                                                        {item.status !== 1 && localStorage.getItem("role") === roles.ops &&
                                                            <span className="hidevisible group-hover/position:visible">
                                                                <sl-tooltip content="Edit Campaign Name">
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="edit"
                                                                        style={{ backgroundColor: "transparent" }}
                                                                        onClick={() => { setEditCampNameInd(index); setEditCampName(item.campaign_name) }}></sl-icon-button>
                                                                </sl-tooltip>
                                                            </span>}
                                                    </div>
                                                }
                                            </h1>
                                            <div class="executive">
                                                <p>{item.sales_name}</p>
                                                <h5 class="duration flex-hor">{index === editstart_date_ind ?
                                                    (
                                                        <div>
                                                            {item.campaign_type === 'CPD' ?
                                                                <input
                                                                    type="datetime-local"
                                                                    className="form-control form-control-sm"
                                                                    min={currentDate}
                                                                    value={ISODateString(editstart_date)}
                                                                    onChange={(e) => {
                                                                        seteditStart_date(new Date(e.target.value) / 1000)
                                                                    }}
                                                                />
                                                                :
                                                                <input
                                                                    type="datetime-local"
                                                                    className="form-control form-control-sm"
                                                                    value={ISODateString(editstart_date)}
                                                                    min={currentDate}
                                                                    onChange={(e) => {
                                                                        seteditStart_date(new Date(e.target.value) / 1000)
                                                                    }}
                                                                />}

                                                            <SlButton size="small" onClick={(e) => {
                                                                if (editstart_date > item.end_date && item.campaign_type !== "CPD")
                                                                    Toast("error", "Start date must be less than end date")
                                                                else if (editstart_date < ((new Date(currentDate)) / 1000))
                                                                    Toast("error", "Start date must be greater than current time")
                                                                else if((item.impclicks[0]?.total_click && item.impclicks[0]?.total_click > 0) || (item.impclicks[0]?.total_imp && item.impclicks[0]?.total_imp > 0))
                                                                    Toast("error", "Start date cannot be changed once the campaign is started")
                                                                else
                                                                    tableEdit("start_date", editstart_date, item.campaign_id, item.campaign_type, item.start_date, item.campaign_name, item); seteditStart_date_ind(-1); seteditStart_date(0)
                                                            }}>Save</SlButton>

                                                            <SlButton size="small" onClick={(e) => { seteditStart_date_ind(-1); seteditStart_date(0) }} type="button">Cancel</SlButton>
                                                        </div>
                                                    ) :
                                                    <div className="flex gap-2 items-center group/start-date">
                                                        <span className="whitespace-nowrap"> {item.campaign_type === 'CPD' ? formatDateWithTime(item.start_date) : formatDateWithTime(item.start_date)}</span>
                                                        {(item.status === 5 && localStorage.getItem("role") === roles.ops && (item.post_ids !== null || (item.creative_type === 'brandAd' || magazineCreatives.includes(item.creative_type) || classifiedCreatives.includes(item.creative_type) || recadCreatives.includes(item.creative_type) || widgetCreatives.includes(item.creative_type)))) ?
                                                            <span className="hidevisible group-hover/start-date:visible">
                                                                <sl-tooltip content="Edit Start Date">
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="edit"
                                                                        onClick={() => { seteditStart_date_ind(index); seteditStart_date(item.start_date) }}></sl-icon-button>
                                                                </sl-tooltip>
                                                            </span>
                                                            : null
                                                        }
                                                    </div>
                                                } - {index === editend_date_ind ?
                                                    (
                                                        <div>
                                                            <div className="mb-1">
                                                                <input
                                                                    type="datetime-local"
                                                                    className="form-control form-control-sm"
                                                                    value={ISODateString(editend_date)}
                                                                    min={currentDate}
                                                                    onChange={(e) => {
                                                                        seteditEnd_date(new Date(e.target.value) / 1000)
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex gap-2">
                                                                <SlButton size="small" onClick={(e) => {
                                                                    if (editend_date < item.start_date)
                                                                        Toast("error", "End date must be greater than Start date")
                                                                    else
                                                                        tableEdit("end_date", editend_date, item.campaign_id, item.campaign_type, item.end_date, item.campaign_name, item); seteditEnd_date_ind(-1); seteditEnd_date(0)
                                                                }}>Save</SlButton>
                                                                <SlButton size="small" onClick={(e) => { seteditEnd_date_ind(-1); seteditEnd_date(0) }} type="button">Cancel</SlButton>
                                                            </div>
                                                        </div>
                                                    ) :
                                                    <div className="flex items-center gap-2 group/end-date">
                                                        <span className="whitespace-nowrap">{item.campaign_type === 'CPD' ? formatDateWithTime(item.end_date) : formatDateWithTime(item.end_date)}</span>
                                                        {((((item.status === 5 || item.status === 2 || item.status === 3) && (item.campaign_type !== 'CPD' || (item.creative_type === 'brandAd' || magazineCreatives.includes(item.creative_type) )) && localStorage.getItem("role") === roles.ops && item.post_ids !== null)) || (item.campaign_type !== 'CPD' && item.status === 4 && localStorage.getItem("role") === roles.ops && item.post_ids !== null && (item.campaign_type === "CPM" ? +item.tot_imp_cap > +item.impclicks[0]?.total_imp : +item.tot_click_cap > +item.impclicks[0]?.total_click)) && (+item.total_budget > (item.campaign_type === "CPC" ? (parseFloat(item.cpc_price) * parseFloat(item.impclicks[0]?.total_click ? item.impclicks[0]?.total_click : 0)).toFixed(2) : ((parseFloat(item.cpm) * parseFloat(item.impclicks[0]?.total_imp ? item.impclicks[0]?.total_imp : 0)) / 1000).toFixed(2)))) &&
                                                            <span className="hidevisible group-hover/end-date:visible transition-all duration-200">
                                                                <sl-tooltip content="Edit End Date">
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="edit"
                                                                        style={{ backgroundColor: "transparent" }}
                                                                        onClick={() => { seteditEnd_date_ind(index); seteditEnd_date(item.end_date) }}></sl-icon-button>
                                                                </sl-tooltip>
                                                            </span>
                                                        }
                                                    </div>
                                                    }</h5>
                                            </div>
                                        </td>

                                        <td className="p-2 wgt-600">
                                            {/* {index === editPosition_ind ?
                                                (<>
                                                    <div className="mb-1">
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm"
                                                            value={editPosition}
                                                            onChange={(e) => {
                                                                seteditPosition(e.target.value)
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <SlButton size="small" onClick={(e) => {
                                                            tableEdit("position", editPosition, item.campaign_id, item.campaign_type, item.position, item.campaign_name, item); seteditPosition_ind(-2); seteditPosition(-2)
                                                        }}>Save</SlButton>
                                                        <SlButton size="small" onClick={(e) => { seteditPosition_ind(-2); seteditPosition(-2) }}>Cancel</SlButton>
                                                    </div>
                                                </>) :
                                                <div className="flex items-center gap-2 group/position"> */}
                                            {item.creative_type !== "brandAd" ? !magazineCreatives.includes(item.creative_type) ? item.position : item.position ? item.position : '-' : '-'}
                                            {/* {item.status !== 4 && item.status !== 1 && localStorage.getItem("role") === roles.ops && item.post_ids !== null && item.creative_type !== 'commentad' &&
                                                        <span className="hidevisible group-hover/position:visible">
                                                            <sl-tooltip content="Edit Position">
                                                                <sl-icon-button
                                                                    library="lucide"
                                                                    name="edit"
                                                                    style={{ backgroundColor: "transparent" }}
                                                                    onClick={() => { seteditPosition_ind(index); seteditPosition(item.position) }}></sl-icon-button>
                                                            </sl-tooltip>
                                                        </span>}
                                                </div>
                                            } */}
                                        </td>
                                        {/* {(localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.financer) && <td className="p-2 wgt-600"> */}
                                        {/* {index === editPriority_ind ?
                                                (<>
                                                    <div className="mb-1">
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm"
                                                            value={editPriority}
                                                            onChange={(e) => {
                                                                seteditPriority(e.target.value)
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <SlButton size="small" onClick={(e) => {
                                                            if (1 <= +editPriority && +editPriority <= 3) {
                                                                tableEdit("priority", editPriority, item.campaign_id, item.campaign_type, item.priority, item.campaign_name, item);
                                                                seteditPriority_ind(-1);
                                                                seteditPriority(-1)
                                                            }
                                                            else {
                                                                Toast("error", "Priority must be in between 1 to 3")
                                                            }
                                                        }}>Save</SlButton>
                                                        <SlButton size="small" onClick={(e) => { seteditPriority_ind(-1); seteditPriority(-1) }}>Cancel</SlButton>
                                                    </div>
                                                </>) :
                                                <div className="flex items-center gap-2 group/priority"> */}
                                        {/* {item.creative_type !== "brandAd" ? item.priority : "-"} */}
                                        {/* {item.status !== 4 && item.status !== 1 && localStorage.getItem("role") === roles.ops && item.post_ids !== null && item.creative_type !== 'commentad' && item.type !== 'DFP' &&
                                                        <span className="hidevisible group-hover/priority:visible">
                                                            <sl-tooltip content="Edit Priority">
                                                                <sl-icon-button
                                                                    library="lucide"
                                                                    name="edit"
                                                                    style={{ backgroundColor: "transparent" }}
                                                                    onClick={() => { seteditPriority_ind(index); seteditPriority(item.priority) }}></sl-icon-button>
                                                            </sl-tooltip>
                                                        </span>}
                                                </div>
                                            } */}
                                        {/* </td>} */}

                                        <td>
                                            <div class="splitView">
                                                <p>{index === editTotalDaily_ind ?
                                                    (
                                                        <>
                                                            <div className="mb-1">
                                                                <input
                                                                    type="number"
                                                                    value={editDailyBudget}
                                                                    className="form-control form-control-sm"
                                                                    onChange={(e) => {
                                                                        seteditDailyBudget(e.target.value)
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex items-center gap-2">
                                                                <SlButton size="small" onClick={(e) => {
                                                                    if (parseFloat(editDailyBudget) > parseFloat(item.total_budget))
                                                                        Toast("error", "Daily budget must be less than Total budget")
                                                                    else
                                                                        tableEdit("daily_budget", editDailyBudget, item.campaign_id, item.campaign_type, item.daily_budget, item.campaign_name, {}); seteditDailyBudget_ind(-1); seteditDailyBudget(0)
                                                                }}>Save</SlButton>
                                                                <SlButton
                                                                    size="small"
                                                                    onClick={(e) => { seteditDailyBudget_ind(-1); seteditDailyBudget(0) }}>Cancel</SlButton>
                                                            </div>
                                                        </>
                                                    ) :
                                                    <div className="flex items-center gap-2 group/daily-budget">
                                                        {item.campaign_type === "CPD" ?
                                                            item.cpd
                                                            : item.daily_budget}
                                                        {item.campaign_type !== 'CPD' && item.status !== 1 && item.status !== 6 && localStorage.getItem("role") === roles.ops &&
                                                            <span className="hidevisible group-hover/daily-budget:visible">
                                                                <sl-tooltip content="Edit Daily Budget">
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="edit"
                                                                        style={{ backgroundColor: "transparent" }}
                                                                        onClick={() => { seteditDailyBudget_ind(index); seteditDailyBudget(item.daily_budget) }}></sl-icon-button>
                                                                </sl-tooltip>
                                                            </span>}
                                                    </div>
                                                }</p>
                                                <div class="devider"></div>
                                                <p>{index === editTotalBudget_ind ?
                                                    (<>
                                                        <div className="mb-1">
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm"
                                                                value={editTotalBudget}
                                                                onChange={(e) => {
                                                                    seteditTotalBudget(e.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="flex gap-2">
                                                            <SlButton size="small" onClick={(e) => {
                                                                if (parseFloat(editTotalBudget) < parseFloat(item.daily_budget))
                                                                    Toast("error", "Total budget must be greater than Daily budget")
                                                                else if ((+editTotalBudget < (item.campaign_type === "CPC" ? (parseFloat(item.cpc_price) * parseFloat(item.impclicks[0]?.adv_total_click ? item.impclicks[0]?.adv_total_click : 0)).toFixed(2) : ((parseFloat(item.cpm) * parseFloat(item.impclicks[0]?.adv_total_imp ? item.impclicks[0]?.adv_total_imp : 0)) / 1000).toFixed(2))))
                                                                    Toast("error", "Total budget must be greater than spent")
                                                                else
                                                                    tableEdit("total_budget", editTotalBudget, item.campaign_id, item.campaign_type, item.total_budget, item.campaign_name, item); seteditTotalBudget_ind(-1); seteditTotalBudget(0)
                                                            }}>Save</SlButton>
                                                            <SlButton size="small" onClick={(e) => { seteditTotalBudget_ind(-1); seteditTotalBudget(0) }}>Cancel</SlButton>
                                                        </div>
                                                    </>) :
                                                    <div className="flex items-center gap-2 group/total-budget">
                                                        {item.campaign_type === "CPD" ?
                                                            item.cpd
                                                            : item.total_budget}
                                                        {item.campaign_type !== 'CPD' && item.status !== 1 && item.status !== 6 && localStorage.getItem("role") === roles.ops &&
                                                            <span className="hidevisible group-hover/total-budget:visible">
                                                                <sl-tooltip content="Edit Total Budget">
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="edit"
                                                                        style={{ backgroundColor: "transparent" }}
                                                                        onClick={() => { seteditTotalBudget_ind(index); seteditTotalBudget(item.total_budget) }}></sl-icon-button>
                                                                </sl-tooltip>
                                                            </span>}
                                                    </div>
                                                }</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="splitView">
                                                <p>{index === editDaily_cap_ind ?
                                                    <>
                                                        <div className="mb-1">
                                                            <input
                                                                type="number"
                                                                value={editDaily_cap}
                                                                className="form-control form-control-sm"
                                                                onChange={(e) => {
                                                                    seteditDaily_cap(e.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="flex gap-3">
                                                            <SlButton size="small" onClick={(e) => {
                                                                if (parseInt(editDaily_cap) > parseInt(item.campaign_type === "CPM" ? item.tot_imp_cap : item.tot_click_cap))
                                                                    Toast("error", "Daily cap must be less than Total cap")
                                                                else
                                                                    tableEdit("daily_cap", editDaily_cap, item.campaign_id, item.campaign_type, item.campaign_type === "CPM" ? item.daily_imp_cap : item.daily_click_cap, item.campaign_name, {}); seteditDaily_cap_ind(-1); seteditDaily_cap(0)
                                                            }}>Save</SlButton>
                                                            <SlButton size="small" onClick={() => { seteditDaily_cap_ind(-1); seteditDaily_cap(0) }}>Cancel</SlButton>
                                                        </div>
                                                    </> :
                                                    <div className="flex items-center gap-2 group/daily-cap">
                                                        {item.campaign_type === "CPC" ? item.daily_click_cap : item.campaign_type === "CPM" ? item.daily_imp_cap : "-"}
                                                        {item.campaign_type !== "CPD" && (item.status !== 1 && item.status !== 6) && localStorage.getItem("role") === roles.ops &&
                                                            <span className="hidevisible group-hover/daily-cap:visible">
                                                                <sl-tooltip content="Edit Daily Cap">
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="edit"
                                                                        style={{ backgroundColor: "transparent" }}
                                                                        onClick={() => { seteditDaily_cap_ind(index); seteditDaily_cap(item.campaign_type === "CPM" ? item.daily_imp_cap : item.daily_click_cap) }}></sl-icon-button>
                                                                </sl-tooltip>
                                                            </span>}
                                                    </div>
                                                }</p>
                                                <div class="devider"></div>
                                                <p>{index === editTotal_cap_ind ?
                                                    <>
                                                        <div className="mb-1">
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm"
                                                                value={editTotal_cap}
                                                                onChange={(e) => {
                                                                    seteditTotal_cap(e.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="flex gap-2">
                                                            <SlButton size="small" onClick={(e) => {
                                                                if (parseInt(editTotal_cap) < parseInt(item.campaign_type === "CPM" ? item.daily_imp_cap : item.daily_click_cap))
                                                                    Toast("error", "Total cap must be greater than Daily cap")
                                                                else
                                                                    tableEdit("total_cap", editTotal_cap, item.campaign_id, item.campaign_type, item.campaign_type === "CPM" ? item.tot_imp_cap : item.tot_click_cap, item.campaign_name, item); seteditTotal_cap_ind(-1); seteditTotal_cap(0)
                                                            }}>Save</SlButton>
                                                            <SlButton size="small" onClick={() => { seteditTotal_cap_ind(-1); seteditTotal_cap(0) }}>Cancel</SlButton>
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="flex items-center gap-2 group/total-cap">
                                                        {item.campaign_type === "CPC" ? item.tot_click_cap : item.campaign_type === "CPM" ? item.tot_imp_cap : "-"}
                                                        {item.campaign_type !== "CPD" && (item.status !== 1 && item.status !== 6) && localStorage.getItem("role") === roles.ops &&
                                                            <span className="hidevisible group-hover/total-cap:visible">
                                                                <sl-tooltip content="Edit Total Cap">
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="edit"
                                                                        style={{ backgroundColor: "transparent" }}
                                                                        onClick={() => { seteditTotal_cap_ind(index); seteditTotal_cap(item.campaign_type === "CPM" ? item.tot_imp_cap : item.tot_click_cap) }}></sl-icon-button>
                                                                </sl-tooltip>
                                                            </span>}
                                                    </div>
                                                }</p>
                                            </div>
                                        </td>
                                        {(localStorage.getItem("role") === roles.ops) &&
                                            <td>
                                                <div class="splitView">
                                                    <p>{parseInt(item.impclicks[0]?.adv_total_click > 0 ? item.impclicks[0]?.adv_total_click : 0)}</p>
                                                    <div class="devider"></div>
                                                    <p>{parseInt(item.impclicks[0]?.adv_total_imp > 0 ? item.impclicks[0]?.adv_total_imp : 0)}</p>
                                                </div>
                                            </td>}
                                        {(localStorage.getItem("role") === roles.ops) && <td>
                                            <div class="splitView">
                                                <p>{item.impclicks[0]?.adv_total_click > 0 && item.impclicks[0]?.adv_total_imp > 0 ? ((item.impclicks[0].adv_total_click / item.impclicks[0].adv_total_imp) * 100).toFixed(2) : 0}%</p>
                                                <div class="devider"></div>
                                                <p>{item.impclicks[0]?.adv_total_imp > 0 && item.adv_spent > 0 ? ((item.adv_spent / item.impclicks[0]?.adv_total_imp) * 1000).toFixed(2) : 0}</p>
                                            </div>
                                        </td>
                                        }
                                        <td>
                                            <div class="splitView">
                                                <p>{(localStorage.getItem("role") === roles.ops) ? (item.impclicks[0]?.total_click ? item.impclicks[0]?.total_click : 0) : parseInt(item.impclicks[0]?.adv_total_click ? item.impclicks[0]?.adv_total_click : 0)}</p>
                                                <div class="devider"></div>
                                                <p>{(localStorage.getItem("role") === roles.ops) ? (item.impclicks[0]?.total_imp ? item.impclicks[0]?.total_imp : 0) : parseInt(item.impclicks[0]?.adv_total_imp ? item.impclicks[0]?.adv_total_imp : 0)}</p>
                                            </div>
                                        </td>
                                        {(localStorage.getItem("role") === roles.ops) &&
                                            <td>
                                                <div class="splitView">
                                                    <p>{item.impclicks[0]?.total_click > 0 && item.impclicks[0]?.total_imp > 0 ? ((item.impclicks[0].total_click / item.impclicks[0].total_imp) * 100).toFixed(2) : 0}%</p>
                                                    <div class="devider"></div>
                                                    <p>{item.impclicks[0]?.total_imp > 0 && item.total_spent > 0 ? ((item.total_spent / item.impclicks[0]?.total_imp) * 1000).toFixed(2) : 0}</p>
                                                </div>
                                            </td>}
                                        <td>
                                            {(localStorage.getItem("role") === roles.ops) ? <div class="splitView">
                                                <p>{(localStorage.getItem("role") === roles.ops) && item.adv_spent}</p>
                                                <div class="devider"></div>
                                                <p>{item.total_spent}</p>
                                            </div> : <p>{item.total_spent}</p>}
                                        </td>
                                        {(localStorage.getItem("role") === roles.ops) && <td className="p-2">{parseInt(item.impclicks[0]?.shares > 0 ? item.impclicks[0]?.shares : 0)}</td>}
                                        {(localStorage.getItem("role") === roles.ops) && <td className="p-2">{item.x_value}</td>}
                                        {((localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops) && dateFilter) ? <td>
                                            <div class="splitView">
                                                <p>{parseInt(item.filterStats?.adv_total_click ? item.filterStats?.adv_total_click : 0)}</p>
                                                <div class="devider"></div>
                                                <p>{parseInt(item.filterStats?.adv_total_imp ? item.filterStats?.adv_total_imp : 0)}</p>
                                            </div>
                                        </td> : null}
                                        {((localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops) && dateFilter) ? <td>
                                            {item.filterSpent}
                                        </td> : null}

                                        <td className="p-2 relative actionsTd" style={{ fontSize: "20px" }}>
                                            {<span style={{ fontSize: "20px" }} className={showActionsMenu === index ? "showMenu" : "hideMenu"}>

                                                {<>{
                                                    localStorage.getItem("role") === roles.ops ? <sl-tooltip content="Clone LineItem" hoist> <sl-icon-button library="lucide"
                                                        name="files" onClick={() => { CloneFun(index, item.campaign_id, 'clone') }}></sl-icon-button></sl-tooltip> : null
                                                }

                                                    {localStorage.getItem("role") === roles.ops ? ((item.status !== 5 && item.status !== 4) ? item.status === 1 ?
                                                        (item?.mc_actions || []).length === 0 ? <sl-tooltip content="Request Approve LineItem" hoist>
                                                            <sl-icon-button
                                                                library="lucide"
                                                                name="file-check"
                                                                className="bg-slate-600"
                                                                onClick={() => {
                                                                    if (item.position === -1) {
                                                                        Toast('error', 'Edit and Set Position for this Lineitem to run')
                                                                    }
                                                                    else if (item.type !== 'DFP' && item.creative_ids.length === 0) {
                                                                        Toast('error', 'Edit and Set Creatives for this Lineitem to run')
                                                                    }
                                                                    else {
                                                                        setisDisabled(false)
                                                                        setLineitemPrev({ index, campaign_id: item.campaign_id, campaign_name: item.campaign_name, act: "approve" })
                                                                    }
                                                                }}
                                                                disabled={isDisabled}
                                                            >
                                                            </sl-icon-button>
                                                        </sl-tooltip> : null : (item.status === 2 ?
                                                            <span >
                                                                <sl-tooltip content="Pause LineItem" hoist>
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="pause-circle"
                                                                        label="Pause LineItem"
                                                                        onClick={() => { setisDisabled(false); editAction(index, item.campaign_id, "pause"); }}
                                                                        disabled={isDisabled}>
                                                                    </sl-icon-button>
                                                                </sl-tooltip>
                                                                <sl-tooltip content="Stop LineItem" hoist>
                                                                    <sl-icon-button
                                                                        library="lucide"
                                                                        name="stop-circle"
                                                                        onClick={() => { setisDisabled(false); setStopMessObj({ stopMess: "", index, campaign_id: item.campaign_id, action: "completed" }) }}
                                                                        disabled={isDisabled}></sl-icon-button>
                                                                </sl-tooltip>
                                                            </span> : item.status === 3 ?
                                                                <span>
                                                                    {<sl-tooltip content="Resume LineItem" hoist>
                                                                        <sl-icon-button
                                                                            library="lucide"
                                                                            name="play-circle"
                                                                            onClick={() => {
                                                                                //  editAction(index, item.campaign_id, "resume"); 
                                                                                setisDisabled(false);
                                                                                setLineitemPrev({ index, campaign_id: item.campaign_id, campaign_name: item.campaign_name, act: "resume" })
                                                                            }}
                                                                            disabled={isDisabled}></sl-icon-button>
                                                                    </sl-tooltip>}
                                                                    <sl-tooltip content="Stop LineItem" hoist>
                                                                        <sl-icon-button
                                                                            library="lucide"
                                                                            name="stop-circle"
                                                                            onClick={() => { setisDisabled(false); setStopMessObj({ stopMess: "", index, campaign_id: item.campaign_id, action: "completed" }) }}
                                                                            disabled={isDisabled}></sl-icon-button>
                                                                    </sl-tooltip>
                                                                </span> : null) : null) : null}</>}
                                                <sl-tooltip content="View LineItem" hoist>
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="view"
                                                        onClick={() => { setLineitemPrev({ index, campaign_id: item.campaign_id, campaign_name: item.campaign_name, act: "preview" });}}></sl-icon-button>
                                                </sl-tooltip>
                                                {<>{(localStorage.getItem("role") === roles.ops && (item.status === 1 || item.status === 2 || (item.status === 5 && Math.floor(new Date().getTime() / 1000) < +item.start_date) || (item.status === 6 && item.admin === "Discount request Pending" && item?.discount_obj?.rejMess))) ? <sl-tooltip content="Edit LineItem" hoist>
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="edit"
                                                        onClick={() => editAction(index, item.campaign_id, "edit")}></sl-icon-button>
                                                </sl-tooltip> : null}
                                                    {(localStorage.getItem("role") === roles.ops && (item.status === 1)) ? <sl-tooltip content="Delete LineItem" hoist>
                                                        <sl-icon-button
                                                            library="lucide"
                                                            name="trash-2"
                                                            onClick={() => { setdelshow(true); setdeldetails({ campaign_id: item.campaign_id, campaign_name: item.campaign_name }) }}></sl-icon-button>
                                                    </sl-tooltip> : null}
                                                    {(localStorage.getItem("role") === roles.ops) ? <sl-tooltip content="Update logs" hoist>
                                                        <sl-icon-button
                                                            library="lucide"
                                                            name="terminal-square"
                                                            onClick={() => { setlogshow({ campaign_name: item.campaign_name, show: true, campaign_type: item.campaign_type }); getlogs(item.campaign_id) }}></sl-icon-button>
                                                    </sl-tooltip> : null}
                                                    {(localStorage.getItem("role") === roles.ops) && (item.status === 2 || item.status === 3 || item.status === 5) ?
                                                        <sl-tooltip content="Assign X Value" hoist>
                                                            <sl-icon-button
                                                                library="lucide"
                                                                name="forward"
                                                                onClick={() => { setxshow({ campaign_id: item.campaign_id, campaign_name: item.campaign_name, show: true, value: null, type: item.type }); setxvalue(item.x_value); }}></sl-icon-button>
                                                        </sl-tooltip> : null
                                                    }
                                                    {(localStorage.getItem("role") === roles.ops) && (item.type === "DFP") ?
                                                        <sl-tooltip content="Clone Multiple" hoist>
                                                            <sl-icon-button
                                                                library="lucide"
                                                                name="rotate-ccw"
                                                                onClick={() => { setDfpCloneMultipleData({campaign_name: item.campaign_name,campaign_id: item.campaign_id, line_item_code: item.line_item_code, start_date: item.start_date}) }}></sl-icon-button>
                                                        </sl-tooltip> : null
                                                    }
                                                    {(localStorage.getItem("role") === roles.ops) && (item.type === "DFP") ?
                                                        <sl-tooltip content="Edit DFP Ad Codes" hoist>
                                                            <sl-icon-button
                                                                library="lucide"
                                                                name="code"
                                                                onClick={() => { setDfpAdCodesData({ campaign_id: item.campaign_id, campaign_name: item.campaign_name, campaign_type: item.campaign_type, type: item.type, ad_codes: (item.dfp_ad_codes || []).join(", "), old_ad_codes: item.dfp_ad_codes || [] }) }}></sl-icon-button>
                                                        </sl-tooltip> : null
                                                    }
                                                    {((item.status === 2 || item.status === 5) && (item.type !== "DFP" && item.creative_type !== 'commentad') && localStorage.getItem("role") === roles.ops) ?
                                                        <sl-tooltip content="Hidden target" hoist>
                                                            <sl-icon-button
                                                                library="lucide"
                                                                name="eye-off"
                                                                style={{ backgroundColor: "transparent" }}
                                                                onClick={() => { moveToHiddenTarget(item) }}></sl-icon-button>
                                                        </sl-tooltip>
                                                        : null}</>}
                                                {<>{((item.status !== 1 && item.status !== 6) && (item.creative_type !== 'commentad') && localStorage.getItem("role") === roles.ops) ?
                                                    <sl-tooltip content="Position Wise Stats" hoist>
                                                        <sl-icon-button
                                                            library="lucide"
                                                            name="pie-chart"
                                                            style={{ backgroundColor: "transparent" }}
                                                            onClick={() => { getPositionWiseStats(item.campaign_id,item.status) }}></sl-icon-button>
                                                    </sl-tooltip>
                                                    : null}</>}
                                                {<>{((item.status !== 1 && item.status !== 6) && (item.creative_type !== 'commentad') && localStorage.getItem("role") === roles.ops) ?
                                                <sl-tooltip content="Actual Stats" hoist>
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="chart-bar"
                                                        style={{ backgroundColor: "transparent" }}
                                                        onClick={() => { getIPBasedStats(item.campaign_id) }}></sl-icon-button>
                                                </sl-tooltip>
                                                : null}</>}
                                                {item.type === 'DFP' && (item.status === 2 || item.status === 3 || item.status === 5) ?
                                                    <sl-tooltip content="Url Encryption" hoist>
                                                        <sl-icon-button
                                                            library="lucide"
                                                            name="shield-check"
                                                            style={{ backgroundColor: "transparent" }}
                                                            onClick={() => { setDfpEncLI({ campaign_id: item.campaign_id, url: "", encUrl: "", loader: false, creative_id: "" }) }}></sl-icon-button>
                                                    </sl-tooltip>
                                                    :
                                                    null}
                                                {(item.status !== 1 && item.status !== 6) && item.type !== 'DFP' && item.creative_type !== 'brandAd' && !magazineCreatives.includes(item.creative_type) && !classifiedCreatives.includes(item.creative_type) && !recadCreatives.includes(item.creative_type) && !widgetCreatives.includes(item.creative_type) ? <sl-tooltip content="Share Link" hoist>
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="share-2"
                                                        onClick={() => { handleShareLinkAction(item.campaign_id) }}></sl-icon-button>
                                                </sl-tooltip> : null}
                                            </span>}
                                            {showActionsMenu !== index ? <sl-tooltip content="Actions" hoist id="clickAction">
                                                <sl-icon-button
                                                    library="lucide"
                                                    name="more-vertical"
                                                    onClick={() => { setShowActionsMenu(index) }}></sl-icon-button>
                                            </sl-tooltip> : <sl-tooltip content="Actions" hoist id="clickAction">
                                                <sl-icon-button
                                                    library="lucide"
                                                    name="more-horizontal"
                                                    onClick={() => { setShowActionsMenu(-1) }}></sl-icon-button>
                                            </sl-tooltip>
                                            }
                                        </td>

                                    </tr>
                                )
                            })}
                        </tbody>
                    ) : !data?.length && !loader ? (
                        <NoDataFound colspan="15" />
                    ) : (
                        <TableLoader colspan="15" />
                    )}
                </table>
            </ScrollContainer>
            </div>
            <SlDrawer
                open={lineitemPrev && Object.keys(lineitemPrev).length > 0}
                onSlAfterHide={() => { closePreview() }}
                style={{ '--size': '1280px' }}>
                <label slot="label" className="d-flex items-center justify-between gap-2">
                    <p className="m-0">{`${lineitemPrev?.campaign_name ? lineitemPrev?.campaign_name : ""}`}</p>
                    {lineitemPrev && Object.keys(lineitemPrev).length && lineitemPrev.act !== 'preview' ? <Button variant="success" onClick={() => { editAction(lineitemPrev.index, lineitemPrev.campaign_id, lineitemPrev.act); closePreview() }}>{lineitemPrev?.act === "resume" ? "Resume" : "Approve"}</Button> : null}
                </label>
                <LineitemPreview campaign_id={lineitemPrev?.campaign_id} />

            </SlDrawer>
            <SlDrawer
                label={`Log details of ${logshow.campaign_name}`}
                style={{ '--size': '50vw' }}
                open={logshow?.show}
                onSlAfterHide={() => { setlogshow({}); setLogdata([]); }}
            >
                <div className="overflow-x-auto">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <td>Name</td>
                                <td>Type</td>
                                <td>Previous</td>
                                <td>Updated</td>
                                <td>Time</td>
                            </tr>
                        </thead>
                        {logdata?.length ? <tbody>
                            {logdata?.map((item) => {
                                return (
                                    <tr>
                                        <td>{capitalizeFirstLetter(item.user_name)}</td>
                                        <td>{item.log.type === "total_cap" ? logshow.campaign_type === "CPM" ? "total impressions" : "total clicks" : item.log.type === "daily_cap" ? logshow.campaign_type === "CPM" ? "daily impressions" : "daily clicks" : capitalizeFirstLetter(`${item.log?.type}`)}</td>
                                        <td>{(item.log.type === "start_date" || item.log.type === "end_date") ? logshow.campaign_type === "CPD" ? formatDate(item.log.previous) : formatDateWithTime(item.log.previous) : (item.log.type === "payment_status") ? paymentNames[item.log?.previous] : capitalizeFirstLetter(`${item.log?.previous}`)}</td>
                                        <td>{(item.log.type === "start_date" || item.log.type === "end_date") ? logshow.campaign_type === "CPD" ? formatDate(item.log.updated) : formatDateWithTime(item.log.updated) : (item.log.type === "payment_status") ? paymentNames[item.log?.updated] : capitalizeFirstLetter(`${item.log?.updated}`)}</td>
                                        <td>{formatDateWithTime(item.time)}</td>
                                    </tr>
                                )
                            })}
                        </tbody> : <NoDataFound></NoDataFound>}
                    </table>
                </div>
            </SlDrawer>

            <SlDrawer
                label={`Position Wise Stats`}
                style={{ '--size': '50vw' }}
                open={positionWise?.length > 0}
                onSlAfterHide={() => { setPositionWise([]) }}
            >
                <div className="overflow-x-auto">
                    <table className="table table-bordered tableNew">
                        <thead className="sticky top-0">
                            <tr>
                                <th>Position</th>
                                <th>Slot</th>
                                <th data-toggle="tooltip" data-placement="top" className="th-width w100px">Adv Clicks/Imp</th>
                                <th data-toggle="tooltip" data-placement="top" className="th-width w100px">Clicks/Imp</th>
                                <th data-toggle="tooltip" data-placement="top" className="th-width w100px">Adv/Actaul Spent</th>
                                <th data-toggle="tooltip" data-placement="top" className="th-width w100px">Shares</th>
                            </tr>
                        </thead>
                        {positionWise?.length ? <tbody>
                            {positionWise?.map((item) => {
                                return (
                                    <tr className={"group/details hover:bg-slate-100"}>
                                        <td>{item.position}</td>
                                        <td>{item.slot === 0 ? 'A' : item.slot === 1 ? 'B' : item.slot === 2 ? 'C' : item.slot === 3 ? 'Backfill' : '-'}</td>
                                        <td>
                                            <div class="splitView">
                                                <p>{item.adv_total_click}</p>
                                                <div class="devider"></div>
                                                <p>{item.adv_total_imp}</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="splitView">
                                                <p>{item.total_click}</p>
                                                <div class="devider"></div>
                                                <p>{item.total_imp}</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="splitView">
                                                <p>{item.adv_spent}</p>
                                                <div class="devider"></div>
                                                <p>{item.total_spent}</p>
                                            </div>
                                        </td>
                                        <td>{item.shares}</td>
                                    </tr>
                                )
                            })}
                        </tbody> : <NoDataFound></NoDataFound>}
                    </table>
                </div>
            </SlDrawer>

            <SlDrawer
                label={`Logs based Stats`}
                style={{ '--size': '50vw' }}
                open={ipBasedStats}
                onSlAfterHide={() => { setIPBasedStats(null) }}
            >
                <div className="overflow-x-auto">
                    <table className="table table-bordered tableNew">
                        <thead className="sticky top-0">
                            <tr>
                                <th>Date</th>
                                <th>Impressions</th>
                                <th>Clicks</th>
                            </tr>
                        </thead>
                        {ipBasedStats?.length ? <tbody>
                            {ipBasedStats?.map((item) => {
                                return (
                                    <tr className={"group/details hover:bg-slate-100"}>
                                        <td>{item.date}</td>
                                        <td>{item.impressions ? item.impressions : 0}</td>
                                        <td>{item.clicks ? item.clicks : 0}</td>
                                    </tr>
                                )
                            })}
                            <tr>
                                <td className="font-bold">Total</td>
                                <td className="font-bold">{ipBasedStats?.reduce((acc, item) => acc + (item.impressions ? item.impressions : 0), 0)}</td>
                                <td className="font-bold">{ipBasedStats?.reduce((acc, item) => acc + (item.clicks ? item.clicks : 0), 0)}</td>
                            </tr>
                        </tbody> : <NoDataFound colspan="3">No data found</NoDataFound>}
                    </table>
                </div>
            </SlDrawer>

            <SlDrawer open={xshow?.show} onSlAfterHide={() => { setxshow({}); setxvalue('') }} >
                <label slot="label">Add X Value</label>
                <p className="mb-5 flex gap-3 items-center"><span>Add X Value to LineItem </span><h6 className="font-semibold ">{` ${xshow.campaign_name}`}</h6></p>
                <div>
                    <p>For DFP line item X value range between 1 to 2</p>
                    <p>Other Than DFP X value should be greater than 1</p>
                </div>
                <div>
                    <div className="mb-3">
                        <input type="number" className="form-control" value={xvalue} onChange={(e) => { setxvalue(e.target.value) }} />
                    </div>
                    <div className="flex gap-3 items-center">
                        <SlButton size="small" variant="danger" onClick={() => { setxshow({}); setxvalue('') }}>Cancel</SlButton>
                        <SlButton size="small" variant="success" onClick={() => { addxvalue(xshow) }}>Confirm</SlButton>
                    </div>
                </div>


            </SlDrawer>

            {/* <SlDrawer open={Object.keys(showMessForm).length} onSlAfterHide={() => { setShowMessForm({})}} >
                                    <label slot="label">Enter Discount Reason</label>
                                    <div>
                                        <div className="mb-3">
                                            <input type="text" className="form-control" value={discMess} onChange={(e) => { setDiscMess(e.target.value) }} />
                                        </div>
                                        <div className="flex gap-3 items-center">
                                            <SlButton size="small" variant="danger" onClick={() => { setShowMessForm({}); setDiscMess('') }}>Cancel</SlButton>
                                            <SlButton size="small" variant="success" onClick={() => { if(discMess.length === 0){Toast("error", "Message is required");}else{updateDiscount(showMessForm.index, showMessForm.id, showMessForm.act, discMess); setDiscMess(""); setShowMessForm({})} }}>Confirm</SlButton>
                                        </div>
                                    </div>
                                </SlDrawer> */}

            <SlDrawer open={Object.keys(orderBudget).length} onSlAfterHide={() => { setOrderBudget({}) }} >
                <label slot="label">Order Details</label>
                <div>
                    <div className="mb-3">
                        <p>Order Value: ₹{orderBudget.order_value}</p>
                        <p>Order Spent: ₹{orderBudget.order_spent}</p>
                        <p>Order Balance: ₹{orderBudget.order_balance}</p>
                        <p>LineItem Budget: ₹{orderBudget.lineItemBudget}</p>
                    </div>
                    <div className="flex gap-3 items-center">
                        <SlButton size="small" variant="danger" onClick={() => { setOrderBudget({}) }}>Cancel</SlButton>
                        <SlButton size="small" variant="success" onClick={() => { insertIntoredis(orderBudget.result1, 'approve'); setOrderBudget({}) }}>Publish</SlButton>
                    </div>
                </div>
            </SlDrawer>
            <Modal
                show={shareLink}
                onHide={() => {
                    setShareLink(null)
                }}
                dialogClassName="modal-30w"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Share Link</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex gap-4 items-center">
                        <p className="border-bottom mb-0">{shareLink}</p> <img
                            src={copySvg}
                            alt="copy"
                            className="hover:cursor-pointer"
                            onClick={() => copyText(shareLink)}
                        ></img>
                    </div>
                </Modal.Body>

            </Modal>

            <Modal show={delshow}>
                <Modal.Header>
                    <Modal.Title>Are you sure!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>The LineItem <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{deldetails.campaign_name}</span> will be deleted</p>
                    <div className=''>
                        <Button variant="success" onClick={() => { setdelshow(false); setdeldetails({}) }}>
                            Cancel
                        </Button>
                        <Button className="ml-2" variant="danger" onClick={() => { setdelshow(false); deleteAction(deldetails.campaign_id) }}>Confirm</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <SlDrawer open={Object.keys(stopMessObj).length} onSlAfterHide={() => { setStopMessObj({}); setisDisabled(null); }} >
                <label slot="label">Reason</label>
                <div>
                    <input
                        placeholder="Message is Required"
                        className="form-control mb-2"
                        type="text"
                        name="stopMessage"
                        value={stopMessObj.stopMess}
                        onChange={(e) => setStopMessObj({ ...stopMessObj, stopMess: e.target.value })}
                    />
                </div>
                <div className="d-flex gap-3">
                    <SlButton size="small" variant="danger" className="w-full"
                        onClick={() => editAction(stopMessObj?.index, stopMessObj?.campaign_id, stopMessObj?.action)}
                        disabled={!stopMessObj?.stopMess}
                    >
                        STOP
                    </SlButton>
                    <SlButton size="small" variant="success" className="w-full"
                        onClick={() => { setStopMessObj({}); setisDisabled(null); }}
                    >
                        Cancel
                    </SlButton>
                </div>
            </SlDrawer>
            <SlDrawer open={Object.keys(dfpEncLI).length} onSlAfterHide={() => { setDfpEncLI({}) }} >
                <label slot="label">Url</label>
                <div className="mt-3">
                    Url :
                    <br />
                    <input
                        placeholder="Url is Required"
                        className="form-control mb-2"
                        type="text"
                        name="Url"
                        value={dfpEncLI.url}
                        onChange={(e) => setDfpEncLI({ ...dfpEncLI, url: e.target.value })}
                    />
                </div>
                <div className="mt-1">
                    Creative Id :
                    <br />
                    <input
                        placeholder="CreativeId is Required"
                        className="form-control mb-2"
                        type="text"
                        name="creative_id"
                        value={dfpEncLI.creative_id}
                        onChange={(e) => setDfpEncLI({ ...dfpEncLI, creative_id: e.target.value })}
                    />
                </div>
                <div className="d-flex gap-3">
                    <SlButton size="small" variant="success" className="w-full"
                        onClick={() => { generateEncUrl(dfpEncLI) }}
                        disabled={!dfpEncLI?.url || !/^\d{12}$/.test(dfpEncLI?.creative_id)}
                    >
                        Generate
                    </SlButton>
                    <SlButton size="small" variant="danger" className="w-full"
                        onClick={() => { setDfpEncLI({}) }}
                    >
                        Cancel
                    </SlButton>
                </div>
                {dfpEncLI?.loader ? <div className="d-flex justify-center w-full mt-3"><TableLoader colspan="17" /></div> : null}
                {dfpEncLI?.encUrl ? <div className="mt-3">
                    Encryption Url :

                    <br />
                    <input
                        placeholder=""
                        className="form-control mb-2"
                        type="text"
                        value={dfpEncLI?.encUrl}
                        disabled={true}
                    />
                </div> : null}
            </SlDrawer>
            <SlDrawer open={Object.keys(dfpAdCodesData).length} onSlAfterHide={() => { setDfpAdCodesData({}) }} >
                <label slot="label">Edit DFP Ad Codes</label>
                <p className="mb-3 flex gap-3 items-center"><span>LineItem </span><h6 className="font-semibold">{` ${dfpAdCodesData.campaign_name || ""}`}</h6></p>
                <div className="mt-3">
                    Ad Codes :
                    <br />
                    <input
                        placeholder="Enter ad codes separated by commas"
                        className="form-control mb-2"
                        type="text"
                        name="dfp_ad_codes"
                        value={dfpAdCodesData.ad_codes || ""}
                        onChange={(e) => setDfpAdCodesData({ ...dfpAdCodesData, ad_codes: e.target.value })}
                    />
                    <p className="text-sm text-gray-500">Enter comma separated ad codes. Eg: APTSFlip3or5T2, APTSFlip9SU1</p>
                </div>
                <div className="d-flex gap-3 mt-3">
                    <SlButton size="small" variant="success" className="w-full"
                        onClick={() => { updateDfpAdCodes(dfpAdCodesData) }}
                        disabled={!(dfpAdCodesData.ad_codes || "").trim()}
                    >
                        Confirm
                    </SlButton>
                    <SlButton size="small" variant="danger" className="w-full"
                        onClick={() => { setDfpAdCodesData({}) }}
                    >
                        Cancel
                    </SlButton>
                </div>
            </SlDrawer>
            {lIReportDetails ? <LineitemReports campaign_id={lIReportDetails?.campaign_id} setLIReportDetails={setLIReportDetails} campaign_name={lIReportDetails.campaign_name} status={lIReportDetails.status} creative_type={lIReportDetails.creative_type} /> : null}
            <SlDrawer
                open={dfpCloneMultipleData && Object.keys(dfpCloneMultipleData).length > 0}
                onSlAfterHide={() => setDfpCloneMultipleData({})}
                style={{ '--size': '50vw' }}
            >
                <label slot="label">Multiple Clone</label>

                {/* NO OF COPIES */}
                <div style={{ marginTop: "16px", fontSize: "14px", color: "#333" }}>
                    <label style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}>
                        No of Copies
                    </label>

                    <input
                        placeholder="Enter No of Copies"
                        type="number"
                        className="form-control"
                        style={{
                            padding: "8px 10px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            width: "100%",
                        }}
                        value={dfpCloneMultipleData?.no_of_copies}
                        onChange={(e) => {
                            let count = Number(e.target.value);
                            if (count < 0) count = 0;

                            let copies = [];

                            for (let i = 0; i < count; i++) {
                                copies.push({
                                    campaign_name: "",
                                    start_date: "",
                                    end_date: "",
                                    errors: {}
                                });
                            }

                            setDfpCloneMultipleData({
                                ...dfpCloneMultipleData,
                                no_of_copies: count,
                                copies_details: copies
                            });
                        }}
                    />
                </div>

                {/* ADD COPY BUTTON */}
                <SlButton
                    variant="primary"
                    size="small"
                    style={{ marginTop: "12px", marginBottom: "15px" }}
                    onClick={() => {
                        const newCopy = {
                            campaign_name: "",
                            start_date: "",
                            end_date: "",
                            errors: {},
                        };

                        setDfpCloneMultipleData({
                            ...dfpCloneMultipleData,
                            no_of_copies: (dfpCloneMultipleData.no_of_copies || 0) + 1,
                            copies_details: [...(dfpCloneMultipleData.copies_details || []), newCopy]
                        });
                    }}
                >
                    + Add Copy
                </SlButton>

                {/* COPY ROWS */}
                {dfpCloneMultipleData?.copies_details?.map((item, index) => {

                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    const tomorrowDate = tomorrow.toISOString().split("T")[0];
                    
                    // VALIDATION FUNCTION
                    const validate = (field, value) => {
                        let errors = { ...item.errors };

                        // Campaign Name
                        if (field === "campaign_name") {
                            const trimmed = value.trim();
                            errors.campaign_name = trimmed === "" ? "Campaign name is required" : "";

                            // Uniqueness check
                            const names = dfpCloneMultipleData.copies_details.map(c => c.campaign_name.trim());
                            const count = names.filter(n => n === trimmed).length;

                            if (count > 1) errors.campaign_name = "Campaign name must be unique";
                        }

                        // Start Date
                        if (field === "start_date") {
                            if (!value) {
                                errors.start_date = "Start date is required";
                            } else if (value < tomorrowDate) {
                                errors.start_date = "Start date cannot be in the past";
                            } else {
                                errors.start_date = "";
                            }

                            if (item.end_date && item.end_date < value) {
                                errors.end_date = "End date must be same or after start date";
                            }
                        }

                        // End Date
                        if (field === "end_date") {
                            if (!value) {
                                errors.end_date = "End date is required";
                            } else if (value < item.start_date) {
                                errors.end_date = "End date must be same or after start date";
                            } else {
                                errors.end_date = "";
                            }
                        }

                        return errors;
                    };

                    return (
                        <div
                            key={index}
                            className="p-3 border rounded mb-3 d-flex flex-col"
                            style={{ background: "#fafafa" }}
                        >
                            {/* Title + Remove */}
                            <div className="d-flex justify-content-between align-items-center mb-2 w-full">
                                <b>Copy {index + 1}</b>

                                <button
                                    style={{
                                        background: "red",
                                        color: "white",
                                        border: "none",
                                        padding: "4px 8px",
                                        borderRadius: "6px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => {
                                        const updated = dfpCloneMultipleData.copies_details.filter((_, i) => i !== index);

                                        setDfpCloneMultipleData({
                                            ...dfpCloneMultipleData,
                                            no_of_copies: updated.length,
                                            copies_details: updated
                                        });
                                    }}
                                >
                                    Remove
                                </button>
                            </div>
                            <div className="d-flex gap-2">
                            {/* CAMPAIGN NAME */}
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}>
                                    Campaign Name
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter Campaign Name"
                                    value={item.campaign_name}
                                    style={{
                                        padding: "8px 10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                        width: "100%",
                                    }}
                                    onChange={(e) => {
                                        const newList = [...dfpCloneMultipleData.copies_details];
                                        newList[index].campaign_name = e.target.value;
                                        newList[index].errors = validate("campaign_name", e.target.value);

                                        setDfpCloneMultipleData({
                                            ...dfpCloneMultipleData,
                                            copies_details: newList
                                        });
                                    }}
                                />
                                {item.errors?.campaign_name && (
                                    <p className="text-danger small">{item.errors.campaign_name}</p>
                                )}
                            </div>

                            {/* START DATE */}
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}>
                                    Start Date
                                </label>
                                <input
                                    type="date"
                                    min={tomorrowDate}
                                    value={item.start_date}
                                    style={{
                                        padding: "8px 10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                        width: "100%",
                                    }}
                                    onChange={(e) => {
                                        const newList = [...dfpCloneMultipleData.copies_details];
                                        newList[index].start_date = e.target.value;
                                        newList[index].errors = validate("start_date", e.target.value);

                                        setDfpCloneMultipleData({
                                            ...dfpCloneMultipleData,
                                            copies_details: newList
                                        });
                                    }}
                                />
                                {item.errors?.start_date && (
                                    <p className="text-danger small">{item.errors.start_date}</p>
                                )}
                            </div>

                            {/* END DATE */}
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}>
                                    End Date
                                </label>
                                <input
                                    type="date"
                                    min={item.start_date || tomorrowDate}
                                    value={item.end_date}
                                    style={{
                                        padding: "8px 10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                        width: "100%",
                                    }}
                                    onChange={(e) => {
                                        const newList = [...dfpCloneMultipleData.copies_details];
                                        newList[index].end_date = e.target.value;
                                        newList[index].errors = validate("end_date", e.target.value);

                                        setDfpCloneMultipleData({
                                            ...dfpCloneMultipleData,
                                            copies_details: newList
                                        });
                                    }}
                                />
                                {item.errors?.end_date && (
                                    <p className="text-danger small">{item.errors.end_date}</p>
                                )}
                            </div>
                            </div>
                        </div>
                    );
                })}

                {/* FINAL ACTION BUTTONS */}
                <div className="d-flex gap-3 mt-3">
                    <SlButton
                        size="small"
                        variant="success"
                        disabled={
                            !dfpCloneMultipleData?.no_of_copies ||
                            dfpCloneMultipleData?.copies_details?.some(
                                (c) =>
                                    !c.campaign_name ||
                                    !c.start_date ||
                                    !c.end_date ||
                                    Object.values(c.errors).some((e) => e)
                            )
                        }
                        onClick={() => {
                            dfpCloneMultiple(JSON.parse(JSON.stringify(dfpCloneMultipleData)));
                            setDfpCloneMultipleData({});
                        }}
                    >
                        Create
                    </SlButton>

                    <SlButton
                        size="small"
                        variant="danger"
                        onClick={() => setDfpCloneMultipleData({})}
                    >
                        Cancel
                    </SlButton>
                </div>
            </SlDrawer>
        </div>
    )
}

export default LineItemsTableView
